export const CorrectIcons = () => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M10.5 0.0361328C4.97715 0.0361328 0.5 4.51329 0.5 10.0361C0.5 15.559 4.97715 20.0361 10.5 20.0361C16.0228 20.0361 20.5 15.559 20.5 10.0361C20.5 4.51329 16.0228 0.0361328 10.5 0.0361328ZM15.3586 7.52356C15.0756 7.04935 14.4616 6.8944 13.9874 7.17749L13.5159 7.45895C11.7136 8.53484 10.1707 9.92174 8.98328 11.5406L7.15778 9.9464C6.7418 9.58311 6.11007 9.62584 5.74679 10.0418C5.38351 10.4578 5.42623 11.0895 5.84222 11.4528L8.51772 13.7893C8.73559 13.9796 9.02517 14.0662 9.31173 14.0268C9.59829 13.9874 9.85375 13.8258 10.0122 13.5838L10.2262 13.2569C11.2843 11.6397 12.7567 10.2414 14.5411 9.17624L15.0126 8.89478C15.4868 8.61169 15.6417 7.99778 15.3586 7.52356Z"
        fill="#12C577"
      />
    </svg>
  );
};

export const BackIcons = () => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      width="20rem"
      height="10rem"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M216.4 163.7c5.1 5 5.1 13.3.1 18.4L155.8 243h231.3c7.1 0 12.9 5.8 12.9 13s-5.8 13-12.9 13H155.8l60.8 60.9c5 5.1 4.9 13.3-.1 18.4-5.1 5-13.2 5-18.3-.1l-82.4-83c-1.1-1.2-2-2.5-2.7-4.1-.7-1.6-1-3.3-1-5 0-3.4 1.3-6.6 3.7-9.1l82.4-83c4.9-5.2 13.1-5.3 18.2-.3z"></path>
    </svg>
  );
};

export const LayoutIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 14.2917V19.0889C1 20.4578 1 21.1421 1.2628 21.6677C1.49425 22.1199 1.86312 22.4989 2.31638 22.7311C2.83232 23 3.50739 23 4.85753 23H9.13699M1 14.2917V4.91105C1 3.54216 1 2.85789 1.2628 2.33233C1.49425 1.88011 1.86312 1.50108 2.31638 1.26885C2.83232 0.999964 3.50739 1 4.85753 1H19.1425C20.4926 1 21.1677 0.999964 21.6836 1.26885C22.1369 1.50108 22.5058 1.88011 22.7372 2.33233C23 2.85789 23 3.54216 23 4.91105V14.2917M1 14.2917H9.13699M23 14.2917V19.0889C23 20.4578 23 21.1421 22.7372 21.6677C22.5058 22.1199 22.1369 22.4989 21.6836 22.7311C21.1677 23 20.4926 23 19.1425 23H9.13699M23 14.2917H9.13699M9.13699 14.2917V23"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ClockIcon = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 7.38889V13.5427C12.5 13.6502 12.5272 13.756 12.579 13.8503C12.6308 13.9446 12.7056 14.0242 12.7964 14.0819L16.3333 16.3333M24 12.5C24 15.55 22.7884 18.475 20.6317 20.6317C18.4751 22.7884 15.55 24 12.5 24C9.45001 24 6.52493 22.7884 4.36826 20.6317C2.21159 18.475 1 15.55 1 12.5C1 9.45001 2.21159 6.52495 4.36826 4.36828C6.52493 2.21161 9.45001 1 12.5 1C15.55 1 18.4751 2.21161 20.6317 4.36828C22.7884 6.52495 24 9.45001 24 12.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AvatarIcon = () => {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.25 3.66667C9.25 4.37391 8.96027 5.05219 8.44455 5.55229C7.92882 6.05238 7.22935 6.33333 6.5 6.33333C5.77065 6.33333 5.07118 6.05238 4.55545 5.55229C4.03973 5.05219 3.75 4.37391 3.75 3.66667C3.75 2.95942 4.03973 2.28114 4.55545 1.78105C5.07118 1.28095 5.77065 1 6.5 1C7.22935 1 7.92882 1.28095 8.44455 1.78105C8.96027 2.28114 9.25 2.95942 9.25 3.66667ZM3.75 9H9.25C9.97935 9 10.6788 9.28095 11.1945 9.78105C11.7103 10.2811 12 10.9594 12 11.6667C12 12.0203 11.8551 12.3594 11.5973 12.6095C11.3394 12.8595 10.9897 13 10.625 13H2.375C2.01033 13 1.66059 12.8595 1.40273 12.6095C1.14486 12.3594 1 12.0203 1 11.6667C1 10.9594 1.28973 10.2811 1.80545 9.78105C2.32118 9.28095 3.02065 9 3.75 9Z"
        stroke="#2F3A79"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TagsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.549" height="23.568" viewBox="0 0 23.549 23.568">
      <g id="analytics-line" transform="translate(0.32 0.445)">
        <g id="Group_4467" data-name="Group 4467" transform="translate(-0.32 -0.445)">
          <path
            id="Path_15563"
            data-name="Path 15563"
            d="M28.424,34.45a3.853,3.853,0,0,1-2.732,1.118,4.115,4.115,0,0,1-2.919-1.211L13.116,24.7a3.619,3.619,0,0,1-1.056-2.453v-7.3a2.939,2.939,0,0,1,.869-2.08A2.816,2.816,0,0,1,14.979,12h7.328a3.606,3.606,0,0,1,2.422,1.056l9.657,9.657a4.021,4.021,0,0,1,.093,5.682Zm4.44-10.185-9.657-9.657a1.334,1.334,0,0,0-.9-.4h-7.3a.893.893,0,0,0-.559.217.748.748,0,0,0-.217.559v7.266a1.346,1.346,0,0,0,.4.932l9.657,9.657a1.859,1.859,0,0,0,2.608.093l6.055-6.055A1.859,1.859,0,0,0,32.864,24.265Z"
            transform="translate(-12.06 -12)"
            fill="#333"
          />
          <path
            id="Path_15564"
            data-name="Path 15564"
            d="M57.488,30.09a3.478,3.478,0,0,1-2.515-1.056h0a3.561,3.561,0,1,1,2.515,1.056Zm.994-4.564a1.425,1.425,0,0,0-1.987,0,1.405,1.405,0,1,0,1.987,1.987A1.445,1.445,0,0,0,58.482,25.526Z"
            transform="translate(-50.533 -19.533)"
            fill="#333"
          />
        </g>
      </g>
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-copy"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
      />
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-share-fill"
      viewBox="0 0 16 16"
    >
      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5" />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.339" height="23.339" viewBox="0 0 23.339 23.339">
      <g id="dashboard" transform="translate(0.15 0.15)">
        <path
          id="Path_8284"
          data-name="Path 8284"
          d="M24,21h1.512v3.78H24Z"
          transform="translate(-8.096 -7.335)"
          fill="#333"
          stroke="#333"
          strokeWidth="0.3"
        />
        <path
          id="Path_8285"
          data-name="Path 8285"
          d="M20,16h1.512v7.56H20Z"
          transform="translate(-6.987 -6.049)"
          fill="#333"
          stroke="#333"
          strokeWidth="0.3"
        />
        <path
          id="Path_8286"
          data-name="Path 8286"
          d="M9.78,23.56A3.784,3.784,0,0,1,6,19.78H7.512A2.268,2.268,0,1,0,9.78,17.512V16a3.78,3.78,0,0,1,0,7.56Z"
          transform="translate(-2.976 -6.049)"
          fill="#333"
          stroke="#333"
          strokeWidth="0.3"
        />
        <path
          id="Path_8287"
          data-name="Path 8287"
          d="M23.394,2H3.646A1.647,1.647,0,0,0,2,3.646V23.394a1.647,1.647,0,0,0,1.646,1.646H23.394a1.648,1.648,0,0,0,1.646-1.646V3.646A1.647,1.647,0,0,0,23.394,2Zm0,7.406H11.874V3.646h11.52ZM10.228,3.646v5.76H3.646V3.646ZM3.646,23.394V11.051H23.394l0,12.343Z"
          transform="translate(-2 -2)"
          fill="#333"
          stroke="#333"
          strokeWidth="0.3"
        />
      </g>
    </svg>
  );
};

export const RightArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
      />
    </svg>
  );
};

export const LeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-left"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 12H12.5M12.5 12H23M12.5 12V1.5M12.5 12V22.5"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MinusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-dash-lg"
      viewBox="0 0 16 16"
    >
      <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8" />
    </svg>
  );
};

export const AddProjectIcon = () => {
  return (
    <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9765 1.91616L13.8812 3.16874C13.7412 5.01143 13.6711 5.93275 13.9844 6.66481C14.2606 7.3081 14.737 7.85044 15.3457 8.21456C16.0386 8.62797 16.9809 8.6996 18.8655 8.84287L20.1465 8.94025M13.9765 1.91616C13.5393 1.81894 13.0121 1.77885 12.1293 1.71173L9.94295 1.54553C7.4302 1.35451 6.17384 1.259 5.17725 1.66423C4.30065 2.02008 3.56306 2.63918 3.07066 3.43241C2.5102 4.33412 2.4168 5.56258 2.23003 8.01949L1.62968 15.9167C1.4429 18.3736 1.34952 19.6021 1.76723 20.5782C2.13406 21.4367 2.76959 22.1602 3.58232 22.6445C4.5062 23.1957 5.76256 23.2912 8.27531 23.4822L11.865 23.7551C14.3777 23.9461 15.6341 24.0416 16.6307 23.6364C17.5073 23.2806 18.2449 22.6615 18.7373 21.8682C19.2977 20.9665 19.3911 19.7381 19.5779 17.2812L20.0739 10.7561C20.1395 9.89287 20.1787 9.37735 20.1465 8.94025M13.9765 1.91616C14.083 1.9397 14.1836 1.96608 14.2828 1.99789C14.7323 2.14017 15.1563 2.35002 15.5397 2.62075C15.9722 2.92722 16.3315 3.33624 17.05 4.15426L18.348 5.6319C19.0666 6.44993 19.4258 6.85892 19.6704 7.32319C19.8862 7.73453 20.0343 8.17604 20.1102 8.6319C20.1274 8.73249 20.1388 8.83376 20.1465 8.94025M10.487 18.1345L10.7372 14.844M10.7372 14.844L10.9873 11.5535M10.7372 14.844L7.3719 14.5882M10.7372 14.844L14.1025 15.0998"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddProjectLightIcon = () => {
  return (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.019 1.06382V2.32001C13.019 4.16801 13.019 5.092 13.3869 5.7982C13.711 6.4187 14.2272 6.92337 14.8618 7.2403C15.584 7.6 16.529 7.6 18.419 7.6H19.7038M13.019 1.06382C12.5758 1.00002 12.047 1 11.1617 1H8.96904C6.44904 1 5.18905 1.00001 4.22605 1.47961C3.37894 1.90088 2.6904 2.57411 2.25955 3.40239C1.76905 4.34399 1.76904 5.57599 1.76904 8.03999V15.96C1.76904 18.424 1.76905 19.656 2.25955 20.5976C2.6904 21.4259 3.37894 22.0991 4.22605 22.5204C5.18905 23 6.44904 23 8.96904 23H12.569C15.089 23 16.349 23 17.312 22.5204C18.1591 22.0991 18.8477 21.4259 19.2785 20.5976C19.769 19.656 19.769 18.424 19.769 15.96V9.4161C19.769 8.5504 19.769 8.0334 19.7038 7.6M13.019 1.06382C13.127 1.07922 13.2294 1.09789 13.3307 1.12209C13.7897 1.22989 14.2284 1.40699 14.6312 1.64789C15.0857 1.92069 15.4749 2.3013 16.2534 3.0625L17.6597 4.4375C18.4382 5.1987 18.8274 5.57928 19.1064 6.02368C19.3528 6.41748 19.5339 6.84649 19.6442 7.29529C19.6689 7.39429 19.688 7.4944 19.7038 7.6M10.769 17.5V14.2M10.769 14.2V10.9M10.769 14.2H7.39404M10.769 14.2H14.144"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SignOutIcon = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.21403 22.0009C2.89385 22.0055 2.57614 21.9444 2.28049 21.8214C1.98484 21.6984 1.71752 21.5162 1.49502 21.2859C1.2647 21.0635 1.08243 20.7961 0.959456 20.5005C0.83648 20.2048 0.775415 19.8871 0.780028 19.5669V14.6979H3.21403V19.5669H20.255V2.52593H3.21403V7.39495H0.780028V2.52593C0.775534 2.20576 0.836655 1.8881 0.959624 1.59246C1.08259 1.29681 1.2648 1.02947 1.49502 0.806933C1.71756 0.576708 1.98489 0.394501 2.28053 0.271532C2.57617 0.148563 2.89386 0.0874112 3.21403 0.0919057H20.255C20.5752 0.0874112 20.8929 0.148563 21.1885 0.271532C21.4842 0.394501 21.7515 0.576708 21.974 0.806933C22.2043 1.02947 22.3865 1.29681 22.5094 1.59246C22.6324 1.8881 22.6935 2.20576 22.689 2.52593V19.5669C22.6936 19.8871 22.6326 20.2048 22.5096 20.5005C22.3866 20.7961 22.2043 21.0635 21.974 21.2859C21.7515 21.5162 21.4842 21.6984 21.1886 21.8214C20.8929 21.9444 20.5752 22.0055 20.255 22.0009H3.21403ZM9.90903 17.1319L8.20903 15.3669L11.309 12.267H0.780028V9.83196H11.309L8.20903 6.73192L9.90903 4.96691L15.995 11.0529L9.90903 17.1319Z"
        fill="#ca373c"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_3141" data-name="Group 3141" transform="translate(-24.2 -24.2)">
        <path
          id="Path_14272"
          data-name="Path 14272"
          d="M29.781,48.2H42.619A5.6,5.6,0,0,0,48.2,42.619h0V38.991a.93.93,0,0,0-1.86,0v3.628a3.732,3.732,0,0,1-3.721,3.721H29.781a3.732,3.732,0,0,1-3.721-3.721V29.781a3.732,3.732,0,0,1,3.721-3.721h3.628a.93.93,0,0,0,0-1.86H29.781A5.6,5.6,0,0,0,24.2,29.781V42.619A5.6,5.6,0,0,0,29.781,48.2Z"
          fill="#333"
        />
        <path
          id="Path_14273"
          data-name="Path 14273"
          d="M50.482,25.677l-9.488,9.488a.9.9,0,0,0-.233.419l-1.3,4.651A.93.93,0,0,0,40.11,41.4a.951.951,0,0,0,.512,0l4.651-1.3a1.886,1.886,0,0,0,.419-.233l9.535-9.488a3.313,3.313,0,0,0,0-4.7,3.369,3.369,0,0,0-4.744,0ZM41.645,39.165l.465-1.581,1.163,1.163Zm12.186-10.14L45.04,37.816,42.994,35.77l8.791-8.791a1.462,1.462,0,0,1,2.047.14A1.478,1.478,0,0,1,53.831,29.026Z"
          transform="translate(-8.142 -0.267)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#ca353b"
          />
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#ca353b"
          />
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#ca353b"
          />
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#ca353b"
          />
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#ca353b"
          />
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#ca353b"
          />
        </g>
      </g>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x-lg"
      viewBox="0 0 16 16"
    >
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-download"
      viewBox="0 0 16 16"
    >
      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
      <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-upload"
      viewBox="0 0 16 16"
    >
      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
      <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
    </svg>
  );
};

export const SimApps = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
      <g id="Group_2822" data-name="Group 2822" transform="translate(-1848 -23)">
        <g id="Group_2823" data-name="Group 2823" transform="translate(-2144 -1086)">
          <g id="Group_2826" data-name="Group 2826" transform="translate(-4)">
            <g id="Path_14087" data-name="Path 14087" transform="translate(4016 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14088" data-name="Path 14088" transform="translate(4016 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14093" data-name="Path 14093" transform="translate(4016 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2825" data-name="Group 2825" transform="translate(-2)">
            <g id="Path_14086" data-name="Path 14086" transform="translate(4004 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14089" data-name="Path 14089" transform="translate(4004 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14092" data-name="Path 14092" transform="translate(4004 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
          <g id="Group_2824" data-name="Group 2824">
            <g id="Path_14085" data-name="Path 14085" transform="translate(3992 1129)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14090" data-name="Path 14090" transform="translate(3992 1119)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
            <g id="Path_14091" data-name="Path 14091" transform="translate(3992 1109)" fill="#636363">
              <path
                d="M 3 5.5 C 1.621500015258789 5.5 0.5 4.378499984741211 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 C 4.378499984741211 0.5 5.5 1.621500015258789 5.5 3 C 5.5 4.378499984741211 4.378499984741211 5.5 3 5.5 Z"
                stroke="none"
              />
              <path
                d="M 3 1 C 1.897200107574463 1 1 1.897200107574463 1 3 C 1 4.102799892425537 1.897200107574463 5 3 5 C 4.102799892425537 5 5 4.102799892425537 5 3 C 5 1.897200107574463 4.102799892425537 1 3 1 M 3 0 C 4.65684986114502 0 6 1.34315013885498 6 3 C 6 4.65684986114502 4.65684986114502 6 3 6 C 1.34315013885498 6 0 4.65684986114502 0 3 C 0 1.34315013885498 1.34315013885498 0 3 0 Z"
                stroke="none"
                fill="#636363"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DropDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-caret-down-fill"
      viewBox="0 0 16 16"
    >
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-check"
      viewBox="0 0 16 16"
    >
      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
    </svg>
  );
};

export const ProjectListiIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.55 4.5273H19.45M9.52187 1.5H16.4781M25 13.7859V18.5477C25 22.7143 22.6 24.5 19 24.5H7C3.4 24.5 1 22.7143 1 18.5477V13.7859C1 10.6312 2.38 8.84552 4.6 8.16696C5.32 7.94078 6.124 7.8336 7 7.8336H19C19.876 7.8336 20.68 7.94078 21.4 8.16696C23.62 8.84552 25 10.6312 25 13.7859Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProjectListActiveIcon = () => {
  return (
    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.3333 13.7859V18.5477C25.3333 22.7143 22.9333 24.5 19.3333 24.5H7.33331C3.73331 24.5 1.33331 22.7143 1.33331 18.5477V13.7859C1.33331 10.6312 2.71331 8.84554 4.93331 8.16698C5.65331 7.9408 6.45731 7.83362 7.33331 7.83362H19.3333C20.2093 7.83362 21.0133 7.9408 21.7333 8.16698C23.9533 8.84554 25.3333 10.6312 25.3333 13.7859Z"
        fill="#2F3A79"
      />
      <path
        d="M6.88331 4.5273H19.7833M9.85518 1.5H16.8114M25.3333 13.7859V18.5477C25.3333 22.7143 22.9333 24.5 19.3333 24.5H7.33331C3.73331 24.5 1.33331 22.7143 1.33331 18.5477V13.7859C1.33331 10.6312 2.71331 8.84552 4.93331 8.16696C5.65331 7.94078 6.45731 7.8336 7.33331 7.8336H19.3333C20.2093 7.8336 21.0133 7.94078 21.7333 8.16696C23.9533 8.84552 25.3333 10.6312 25.3333 13.7859Z"
        stroke="#0F0F1C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const BackArrowIcon = () => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.35833 1C4.60935 2.29326 3.03515 3.80752 1.675 5.505C1.56182 5.64516 1.50006 5.81985 1.5 6M1.5 6C1.50006 6.18015 1.56182 6.35484 1.675 6.49499C3.03515 8.19248 4.60935 9.70674 6.35833 11M1.5 6H16.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CircleLoading = () => {
  return (
    <svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50">
        {""}
      </circle>
    </svg>
  );
};

export const HotspotIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.62555 5.37545L5.37445 8.62455M5.9163 2.66272L6.45815 2.12634C6.81332 1.76937 7.23553 1.48608 7.70054 1.29279C8.16555 1.09949 8.66419 1 9.16778 1C9.67137 1 10.17 1.09949 10.635 1.29279C11.1 1.48608 11.5222 1.76937 11.8774 2.12634C12.2333 2.48201 12.5156 2.90426 12.7082 3.36906C12.9009 3.83385 13 4.33212 13 4.83524C13 5.33836 12.9009 5.83653 12.7082 6.30133C12.5156 6.76613 12.2333 7.18837 11.8774 7.54404L11.3355 8.08051M2.66445 5.91949L2.1226 6.45596C1.76671 6.81163 1.48438 7.23387 1.29176 7.69867C1.09914 8.16347 1 8.66164 1 9.16476C1 9.66788 1.09914 10.1661 1.29176 10.6309C1.48438 11.0957 1.76671 11.518 2.1226 11.8737C2.47777 12.2306 2.89999 12.5139 3.36499 12.7072C3.83 12.9005 4.32863 13 4.83222 13C5.33581 13 5.83445 12.9005 6.29946 12.7072C6.76447 12.5139 7.18668 12.2306 7.54185 11.8737L8.0837 11.3373"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HotspotImageIcon = () => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 6.65446C16.356 6.51446 15.6864 6.44444 15 6.44444C10.056 6.44444 6.0224 10.2322 5.8088 14.9922M17 6.65446V8.77778C17 10.9556 17 12.0445 16.564 12.8767C16.1805 13.6094 15.5687 14.2055 14.816 14.58C13.96 15 12.84 15 10.6 15H7.4C6.7928 15 6.2688 15 5.8088 14.9922M17 6.65446C16.9968 4.85002 16.9608 3.87776 16.564 3.12332C16.1805 2.39064 15.5687 1.79453 14.816 1.42003C13.96 1.00003 12.84 1 10.6 1H7.4C5.16 1 4.04 1.00003 3.184 1.42003C2.43126 1.79453 1.81948 2.39064 1.436 3.12332C0.999999 3.95554 1 5.04444 1 7.22222V8.77778C1 10.9556 0.999999 12.0445 1.436 12.8767C1.81948 13.6094 2.43126 14.2055 3.184 14.58C3.808 14.8833 4.572 14.9689 5.8088 14.9922M5.4 6.44444C5.23986 6.44852 5.0805 6.42135 4.93132 6.3646C4.78215 6.30784 4.64617 6.22261 4.53141 6.11395C4.41664 6.00529 4.32542 5.87547 4.26311 5.73199C4.2008 5.58851 4.16867 5.43428 4.16862 5.27854C4.16856 5.12279 4.20058 4.96861 4.26279 4.82509C4.325 4.68157 4.41615 4.55167 4.53084 4.44294C4.64552 4.33421 4.78144 4.24885 4.93058 4.192C5.07972 4.13515 5.23905 4.1079 5.39919 4.11187C5.71199 4.11962 6.00931 4.24584 6.22776 4.46364C6.44621 4.68143 6.56851 4.97357 6.56862 5.27778C6.56872 5.58198 6.44661 5.87417 6.22831 6.09211C6.01001 6.31004 5.71279 6.43649 5.4 6.44444Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HotspotTextIcon = () => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 15V9M7 15V1M11 9H17M1 1H13"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const XIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 22.5L12 12M12 12L22 1.5M12 12L2 1.50001M12 12L22 22.5"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LayersIcon = () => {
  return (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1.00001C1.95887 2.32057 3.08783 3.50876 4.35771 4.53381C4.43482 4.59598 4.53094 4.62988 4.63 4.62988C4.72906 4.62988 4.82518 4.59598 4.90229 4.53381C6.17217 3.50876 7.30113 2.32057 8.26 1.00001"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className="__web-inspector-hide-shortcut__"
    >
      <path
        fill="currentColor"
        d="m6.1 17.8.73.73 1.3-.49a4.5 4.5 0 0 0 1.48-.91L7.5 15.01c-.4.43-.7.94-.91 1.48L6.1 17.8zm2.46-3.85 2.12 2.12 7.39-7.4-2.12-2.11-7.4 7.4zM17 5.5l2.12 2.12.83-.83a1.5 1.5 0 0 0-2.12-2.12L17 5.5zm4.01-1.9a3 3 0 0 1 0 4.25L10.8 18.07a6 6 0 0 1-2.14 1.38l-4 1.49a.75.75 0 0 1-.97-.97l1.5-4a6 6 0 0 1 1.37-2.15L16.78 3.61a3 3 0 0 1 4.24 0z"
      ></path>
    </svg>
  );
};

export const SaveCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-check-lg"
      viewBox="0 0 16 16"
    >
      <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
    </svg>
  );
};

export const SaveCloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x-lg"
      viewBox="0 0 16 16"
    >
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
    </svg>
  );
};

export const SceneIcon = () => {
  return (
    <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.5513 0.569327C18.1216 0.485344 17.6785 0.497751 17.2542 0.605656C16.8298 0.71356 16.4346 0.914273 16.0972 1.19333C15.7534 1.47588 15.4767 1.83125 15.2869 2.23377C15.0972 2.63629 14.9992 3.07593 15 3.52093V5.88373C13.003 6.03903 10.997 6.03903 9 5.88373V3.52093C9.00083 3.07593 8.90283 2.63629 8.71309 2.23377C8.52335 1.83125 8.24659 1.47588 7.9028 1.19333C7.56553 0.913669 7.17025 0.712583 6.74562 0.604653C6.321 0.496724 5.87767 0.484656 5.4478 0.569327C1.833 1.27733 0 2.43213 0 4.00093V17.0009C0 20.1586 7.543 21.0009 12 21.0009C16.457 21.0009 24 20.1586 24 17.0009V4.00093C24 2.43213 22.167 1.27733 18.5513 0.569327ZM17 3.52093C16.9996 3.37103 17.0325 3.22292 17.0963 3.0873C17.1601 2.95167 17.2533 2.83193 17.3691 2.73673C17.4783 2.64483 17.6067 2.57872 17.7449 2.54331C17.8832 2.50791 18.0276 2.50412 18.1675 2.53223C21.0356 3.09373 21.9219 3.83003 22.0063 3.95793C21.8663 4.31293 20.4121 5.17333 17 5.66013V3.52093ZM12 8.00093C13.3688 8.0054 14.7368 7.93368 16.0977 7.78613L16.1187 7.78413C18.1403 7.6267 20.1247 7.15381 22 6.38263V12.5868L20.1172 10.704C19.5554 10.1431 18.7939 9.8281 18 9.8281C17.2061 9.8281 16.4446 10.1431 15.8828 10.704L11.5 15.0868L10.1172 13.704C9.55536 13.1431 8.7939 12.8281 8 12.8281C7.2061 12.8281 6.44464 13.1431 5.8828 13.704L2.2892 17.2976C2.16835 17.2259 2.06858 17.1236 2 17.0009V6.38273C3.87889 7.15513 5.8672 7.62833 7.8926 7.78513C9.25666 7.93333 10.6279 8.00537 12 8.00093ZM5.8315 2.53223C5.89394 2.52007 5.95739 2.51385 6.021 2.51363C6.24399 2.51534 6.45952 2.59417 6.631 2.73673C6.74676 2.83194 6.83992 2.95169 6.90373 3.08731C6.96755 3.22293 7.00043 3.37104 7 3.52093V5.66093C3.6129 5.17893 2.1567 4.33463 2 4.05093V4.03473C2.1013 3.81193 2.9962 3.08743 5.8315 2.53223ZM12 19.0009C9.40642 19.043 6.81855 18.7442 4.3028 18.1122L7.2969 15.1181C7.48351 14.9319 7.73637 14.8273 8 14.8273C8.26363 14.8273 8.51649 14.9319 8.7031 15.1181L11.2931 17.7081C11.3859 17.801 11.4961 17.8747 11.6174 17.925C11.7387 17.9753 11.8688 18.0012 12.0001 18.0012C12.1314 18.0012 12.2614 17.9753 12.3828 17.925C12.5041 17.8747 12.6143 17.801 12.7071 17.7081C12.856 17.5573 12.9525 17.3626 12.9823 17.1528C13.012 16.9429 12.9735 16.7291 12.8724 16.5428L17.297 12.1183C17.4836 11.9321 17.7365 11.8275 18.0001 11.8275C18.2637 11.8275 18.5166 11.9321 18.7032 12.1183L22 15.415V16.0009L22.0063 16.9584C21.7266 17.6709 18.0435 19.0009 12 19.0009Z"
        fill="black"
      />
    </svg>
  );
};

export const NoDataImage = () => {
  return (
    <svg width="345" height="287" viewBox="0 0 345 287" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3694_8732)">
        <g filter="url(#filter0_d_3694_8732)">
          <path
            d="M153.54 54.5382C153.473 54.5382 153.406 54.5358 153.339 54.5316C148.913 54.2473 133.77 52.1057 124.726 36.4726C124.058 35.3187 124.19 33.8504 125.055 32.8199C132.607 26.6791 138.507 20.033 141.989 12.6482C142.618 11.899 143.562 11.4895 144.517 11.5064C145.498 11.5295 146.401 11.9912 146.997 12.7729C151.29 18.4135 159.767 28.3988 168.297 31.8997C169.255 32.2936 169.949 33.0927 170.201 34.0937C170.45 35.0862 170.219 36.1094 169.567 36.9008L156.001 53.3699C155.391 54.1106 154.483 54.5382 153.54 54.5382Z"
            fill="#E6E6E6"
          />
          <path
            d="M127.854 33.8121C127.623 34.0879 127.581 34.4812 127.749 34.792C135.931 49.8536 150.558 51.0352 153.407 51.1189C153.682 51.1346 153.939 51.0111 154.113 50.7997L167.582 34.4493C167.773 34.2174 167.831 33.9217 167.744 33.6362C167.655 33.3496 167.438 33.1358 167.147 33.0515C157.999 30.3787 148.401 17.9989 145.677 14.2679C145.518 14.0499 145.272 13.9192 145.003 13.9102C144.726 13.9075 144.474 14.0162 144.297 14.2258C140.4 21.8228 134.943 28.3679 127.854 33.8121Z"
            fill="white"
          />
          <path
            d="M134.637 37.3389L146.846 24.8935C147.681 24.0427 146.373 22.7334 145.537 23.5853L133.328 36.0307C132.494 36.8814 133.801 38.1907 134.637 37.3389Z"
            fill="#E6E6E6"
          />
          <path
            d="M142.006 40.8469C145.375 37.8275 148.304 34.3315 150.701 30.4953C151.334 29.4827 149.734 28.5529 149.103 29.5615C146.785 33.2703 143.955 36.6199 140.697 39.5387C139.809 40.335 141.121 41.6399 142.006 40.8469Z"
            fill="#E6E6E6"
          />
          <path
            d="M148.648 45.0439C151.715 41.6463 154.327 37.8545 156.383 33.7643C156.916 32.7032 155.32 31.7653 154.785 32.8305C152.799 36.7824 150.304 40.4523 147.339 43.7356C146.543 44.6175 147.847 45.9299 148.648 45.0439Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter1_d_3694_8732)">
          <path
            d="M164.643 59.4718C164.576 59.4718 164.509 59.4694 164.442 59.4652C160.017 59.1809 144.874 57.0393 135.83 41.4062C135.162 40.2522 135.294 38.784 136.158 37.7535C143.334 31.5317 148.736 24.7282 153.093 17.5818C153.722 16.8326 154.666 16.4231 155.621 16.44C156.601 16.4631 157.505 16.9248 158.1 17.7065C162.394 23.3471 170.871 33.3324 179.4 36.8333C180.359 37.2272 181.053 38.0263 181.304 39.0273C181.554 40.0198 181.323 41.043 180.671 41.8344L167.105 58.3034C166.495 59.0442 165.586 59.4718 164.643 59.4718Z"
            fill="#E6E6E6"
          />
          <path
            d="M138.958 38.7457C138.727 39.0215 138.685 39.4148 138.853 39.7256C147.035 54.7872 161.662 55.9688 164.511 56.0525C164.785 56.0682 165.042 55.9447 165.216 55.7333L178.686 39.3829C178.876 39.151 178.935 38.8553 178.847 38.5698C178.759 38.2832 178.541 38.0694 178.25 37.9851C169.103 35.3123 159.505 22.9325 156.781 19.2015C156.621 18.9835 156.375 18.8528 156.106 18.8438C155.829 18.8411 155.577 18.9498 155.401 19.1594C150.732 26.9152 145.48 33.7903 138.958 38.7457Z"
            fill="white"
          />
          <path
            d="M145.74 42.2725L157.95 29.8271C158.784 28.9763 157.477 27.667 156.641 28.5188L144.432 40.9643C143.597 41.815 144.905 43.1243 145.74 42.2725Z"
            fill="#E6E6E6"
          />
          <path
            d="M153.109 45.7805C156.479 42.7611 159.407 39.265 161.805 35.4289C162.438 34.4163 160.837 33.4865 160.207 34.4951C157.889 38.2039 155.058 41.5535 151.801 44.4722C150.912 45.2686 152.224 46.5735 153.109 45.7805Z"
            fill="#E6E6E6"
          />
          <path
            d="M159.751 49.9775C162.819 46.5799 165.43 42.7881 167.486 38.6979C168.02 37.6368 166.424 36.6989 165.888 37.7641C163.902 41.716 161.407 45.3859 158.443 48.6692C157.646 49.5511 158.951 50.8635 159.751 49.9775Z"
            fill="#E6E6E6"
          />
        </g>
        <g filter="url(#filter2_d_3694_8732)">
          <path
            d="M286.164 174.179C286.097 174.179 286.03 174.176 285.963 174.172C281.538 173.888 266.395 171.746 257.351 156.113C256.683 154.959 256.815 153.491 257.679 152.461L274.614 132.289C275.243 131.54 276.187 131.13 277.142 131.147C278.122 131.17 279.381 131.461 279.621 132.414C281.572 140.155 289.974 150.207 300.921 151.54C301.95 151.666 302.574 152.733 302.825 153.734C303.075 154.727 302.844 155.75 302.192 156.541L288.626 173.01C288.016 173.751 287.107 174.179 286.164 174.179Z"
            fill="#E6E6E6"
          />
          <path
            d="M260.479 153.453C260.248 153.729 260.206 154.122 260.374 154.433C268.556 169.494 283.183 170.676 286.032 170.76C286.306 170.775 286.563 170.652 286.737 170.44L300.207 154.09C300.397 153.858 300.456 153.562 300.368 153.277C300.28 152.99 300.074 152.706 299.771 152.692C288.127 152.146 278.775 139.557 278.302 133.909C278.279 133.64 277.896 133.56 277.627 133.551C277.35 133.548 277.098 133.657 276.922 133.866L260.479 153.453Z"
            fill="white"
          />
          <path
            d="M267.261 156.98L279.47 144.534C280.305 143.683 278.998 142.374 278.162 143.226L265.953 155.671C265.118 156.522 266.426 157.831 267.261 156.98Z"
            fill="#E6E6E6"
          />
          <path
            d="M274.63 160.487C278 157.468 280.928 153.972 283.326 150.136C283.959 149.123 282.358 148.194 281.728 149.202C279.41 152.911 276.579 156.261 273.322 159.179C272.433 159.976 273.745 161.28 274.63 160.487Z"
            fill="#E6E6E6"
          />
          <path
            d="M281.272 164.684C284.34 161.287 286.951 157.495 289.007 153.405C289.541 152.344 287.945 151.406 287.409 152.471C285.423 156.423 282.928 160.093 279.964 163.376C279.167 164.258 280.472 165.571 281.272 164.684Z"
            fill="#E6E6E6"
          />
        </g>
        <path
          d="M311.53 276.311C312.804 276.391 313.509 274.808 312.544 273.885L312.449 273.504C312.461 273.474 312.474 273.443 312.487 273.413C313.775 270.34 318.143 270.362 319.421 273.438C320.555 276.169 321.999 278.905 322.355 281.792C322.514 283.067 322.442 284.365 322.159 285.616C324.817 279.812 326.215 273.475 326.215 267.102C326.215 265.501 326.128 263.9 325.948 262.302C325.801 260.996 325.598 259.697 325.335 258.411C323.913 251.456 320.833 244.832 316.39 239.299C314.255 238.132 312.474 236.308 311.398 234.121C311.012 233.333 310.709 232.484 310.565 231.62C310.808 231.652 311.482 227.951 311.299 227.724C311.637 227.21 312.243 226.955 312.613 226.454C314.453 223.96 316.988 224.395 318.311 227.784C321.137 229.21 321.165 231.576 319.43 233.85C318.327 235.298 318.175 237.256 317.207 238.805C317.307 238.933 317.41 239.056 317.51 239.184C319.336 241.526 320.916 244.043 322.248 246.688C321.872 243.749 322.427 240.208 323.375 237.925C324.453 235.324 326.474 233.134 328.254 230.886C330.392 228.185 334.777 229.363 335.153 232.787C335.157 232.82 335.16 232.853 335.164 232.886C334.9 233.036 334.641 233.194 334.388 233.361C332.944 234.315 333.443 236.552 335.153 236.816L335.192 236.822C335.096 237.774 334.933 238.718 334.694 239.646C336.977 248.475 332.047 251.69 325.008 251.835C324.853 251.914 324.701 251.994 324.546 252.07C325.259 254.077 325.829 256.136 326.251 258.224C326.63 260.068 326.893 261.932 327.04 263.804C327.223 266.166 327.207 268.54 327.008 270.898L327.02 270.814C327.526 268.217 328.937 265.792 330.985 264.111C334.035 261.605 338.345 260.683 341.637 258.669C343.221 257.699 345.251 258.952 344.975 260.788L344.961 260.876C344.471 261.076 343.993 261.307 343.531 261.565C343.266 261.715 343.007 261.873 342.754 262.04C341.311 262.995 341.81 265.231 343.52 265.495L343.559 265.501C343.587 265.505 343.61 265.509 343.638 265.513C342.798 267.508 341.626 269.361 340.16 270.958C338.732 278.665 332.6 279.396 326.04 277.152H326.036C325.319 280.275 324.271 283.326 322.924 286.233H311.809C311.769 286.11 311.733 285.982 311.697 285.859C312.725 285.923 313.761 285.863 314.773 285.676C313.948 284.664 313.123 283.644 312.299 282.633C312.279 282.613 312.263 282.593 312.247 282.573C311.828 282.055 311.406 281.541 310.988 281.023L310.988 281.023C310.961 279.433 311.152 277.849 311.53 276.311Z"
          fill="#F2F2F2"
        />
        <path
          d="M-19 286.5C-19 286.777 -18.4724 287 -17.8154 287H343.815C344.472 287 345 286.777 345 286.5C345 286.223 344.472 286 343.815 286H-17.8154C-18.4724 286 -19 286.223 -19 286.5Z"
          fill="#CCCCCC"
        />
        <g filter="url(#filter3_d_3694_8732)">
          <path d="M235.432 281.703L228.116 281.702L224.636 253.492L235.433 253.493L235.432 281.703Z" fill="#FFB6B6" />
          <path
            d="M210.368 281.537C210.14 281.92 210.02 283.158 210.02 283.604C210.02 284.975 211.132 286.086 212.503 286.086H235.158C236.093 286.086 236.852 285.328 236.852 284.393V283.45C236.852 283.45 237.972 280.616 235.665 277.123C235.665 277.123 232.797 279.858 228.512 275.574L227.248 273.285L218.101 279.973L213.031 280.597C211.922 280.734 210.939 280.576 210.368 281.537Z"
            fill="black"
          />
          <path d="M302.983 267.27L296.752 271.102L279.003 248.897L288.199 243.242L302.983 267.27Z" fill="#FFB6B6" />
          <path
            d="M281.549 280.257C281.556 280.703 282.102 281.821 282.336 282.2C283.055 283.368 284.584 283.732 285.752 283.014L305.048 271.146C305.845 270.656 306.093 269.613 305.603 268.817L305.109 268.014C305.109 268.014 304.578 265.013 300.782 263.246C300.782 263.246 299.773 267.078 293.878 265.674L291.602 264.387L287.316 274.875L283.325 278.062C282.452 278.759 281.531 279.14 281.549 280.257Z"
            fill="black"
          />
          <path
            d="M257.004 149.761C256.642 148.182 256.669 146.649 257.009 145.378L252.601 130.561L259.778 128.615L263.476 143.856C264.334 144.844 265.026 146.208 265.388 147.787C266.215 151.395 265.009 154.761 262.694 155.306C260.378 155.851 257.831 153.368 257.004 149.761Z"
            fill="#FFB6B6"
          />
          <path
            d="M216.17 50.9892C216.17 50.9892 227.736 45.9563 234.194 53.2292C240.072 59.8489 252.005 79.7687 250.779 81.7068L262.526 137.2L253.819 139.882L230.721 76.0517L216.17 50.9892Z"
            fill="#2F3A79"
          />
          <path
            d="M203.433 133.228L209.392 202.733L223.793 267.272L239.187 265.783L231.738 195.286L236.298 132.635L203.433 133.228Z"
            fill="black"
          />
          <path
            d="M204.665 148.309L241.781 207.381L284.13 258.176L297.135 249.808L258.241 190.535C252.288 164.426 245.695 140.257 233.614 132.744L204.665 148.309Z"
            fill="black"
          />
          <path
            d="M206.831 148.598C205.09 148.598 203.404 147.984 202.03 146.82C200.185 145.256 199.224 142.976 199.393 140.564L202.631 109.508L201.394 75.5954L201.402 75.5587L205.246 57.1299C205.284 56.5442 205.407 55.9242 205.605 55.3288L211.283 38.2629C212.304 35.1933 215.163 33.1309 218.399 33.1309H223.42C225.934 33.1309 228.267 34.379 229.661 36.47L234.056 43.061C234.348 43.4989 234.594 43.9689 234.788 44.4582L244.491 68.9405C244.799 69.7177 244.974 70.5353 245.012 71.3703L248.022 139.316C248.122 141.571 247.215 143.73 245.532 145.238C243.86 146.738 241.629 147.401 239.416 147.059C226.746 145.103 215.657 146.703 208.584 148.39C208 148.529 207.412 148.598 206.831 148.598Z"
            fill="#2F3A79"
          />
          <path
            d="M205.419 81.0995L196.978 74.6456C196.978 74.6456 200.95 39.397 211.379 39.397C221.807 39.397 227.269 33.4395 227.269 33.4395C227.269 33.4395 264.513 85.5677 254.085 91.5252C243.657 97.4827 229.256 94.504 229.256 94.504L224.183 49.9726C223.56 47.6186 220.32 47.3637 219.336 49.5913L205.419 81.0995Z"
            fill="#CA373C"
          />
          <path
            d="M219.307 31.6119C227.279 31.6119 233.742 25.1509 233.742 17.1809C233.742 9.21095 227.279 2.75 219.307 2.75C211.335 2.75 204.873 9.21095 204.873 17.1809C204.873 25.1509 211.335 31.6119 219.307 31.6119Z"
            fill="#FFB6B6"
          />
          <path
            d="M230.738 28.0909C229.436 28.5769 227.44 29.3326 226.138 29.8187C224.923 27.3985 226.411 26.1427 226.566 23.4395C226.617 22.5374 226.747 21.6343 226.672 20.7338C226.598 19.8334 226.288 18.909 225.609 18.3132C224.569 17.4017 222.838 17.55 221.832 18.4979C220.826 19.4458 220.539 21.0122 220.951 22.3319C216.993 20.6214 214.436 16.1341 214.982 11.8582C213.8 11.3949 212.589 10.9255 211.32 10.89C210.051 10.8546 208.691 11.3387 208.015 12.4129C207.541 13.1661 207.446 14.1223 206.914 14.8357C206.049 15.995 204.18 16.0848 203.032 15.2055C201.884 14.3261 201.444 12.728 201.689 11.3028C201.934 9.87757 200.152 6.96906 201.15 5.92183C201.83 5.20743 205.208 6.21968 205.967 5.58948C206.659 5.01453 207.355 4.43767 208.118 3.96069C209.087 3.35524 210.16 2.91678 211.276 2.67041C212.332 2.43736 213.416 2.37615 214.496 2.31568C215.591 2.25429 217.107 0.0731585 218.203 0.0117658C221.429 -0.168977 224.312 1.77848 227.407 2.70564C230.502 3.63281 232.449 6.29529 234.162 9.03402C236.602 12.9351 235.773 17.2095 234.092 20.9397C233.677 21.8618 235.071 22.8307 234.864 23.8206C234.673 24.7408 233.81 25.4073 233.609 26.3254C233.436 27.1105 232.417 26.2009 232.174 26.9671C231.964 27.6282 231.346 28.0949 230.685 28.3059C230.024 28.517 229.317 28.5127 228.623 28.5064"
            fill="black"
          />
          <path
            d="M227.64 33.0703L228.148 33.4406L229.431 34.3742C233.287 37.1809 232.929 43.0398 228.759 45.3557L223.545 37.0292"
            fill="#CA373C"
          />
          <path
            d="M154.843 50.2438C156.145 51.1026 157.145 52.1841 157.753 53.2875L170.67 60.6858L166.969 66.7279L154.264 58.5726C153.01 58.4476 151.622 57.9539 150.321 57.0951C147.347 55.1331 145.948 52.009 147.197 50.117C148.446 48.2251 151.869 48.2818 154.843 50.2438Z"
            fill="#FFB6B6"
          />
          <path
            d="M215.62 42.4458C223.857 37.3952 232.135 48.9615 224.811 55.2633L224.786 55.2847L195.521 82.8029L160.497 65.512L163.96 56.1762L191.095 66.9224L211.45 45.7967C212.867 44.3784 214.261 43.2792 215.62 42.4458Z"
            fill="#2F3A79"
          />
        </g>
        <path
          d="M42.1282 88.3926C41.4478 88.3926 40.8945 88.9457 40.8945 89.626V108.744C40.8945 109.424 41.4478 109.977 42.1282 109.977C42.8087 109.977 43.362 109.424 43.362 108.744V89.626C43.362 88.9457 42.8087 88.3926 42.1282 88.3926Z"
          fill="black"
        />
        <path
          d="M54.2193 106.814C58.4653 106.814 61.9074 103.445 61.9074 99.2898C61.9074 95.1343 58.4653 91.7656 54.2193 91.7656C49.9733 91.7656 46.5312 95.1343 46.5312 99.2898C46.5312 103.445 49.9733 106.814 54.2193 106.814Z"
          fill="url(#paint0_radial_3694_8732)"
        />
        <path
          d="M115.851 96.7165H74.4693C73.0496 96.7165 71.8945 95.5617 71.8945 94.1424C71.8945 92.7231 73.0496 91.5684 74.4693 91.5684H115.851C117.271 91.5684 118.426 92.7231 118.426 94.1424C118.426 95.5617 117.271 96.7165 115.851 96.7165Z"
          fill="white"
        />
        <path
          d="M148.146 105.429H74.4693C73.0496 105.429 71.8945 104.275 71.8945 102.855C71.8945 101.436 73.0496 100.281 74.4693 100.281H148.146C149.565 100.281 150.72 101.436 150.72 102.855C150.72 104.275 149.565 105.429 148.146 105.429Z"
          fill="white"
        />
        <path
          d="M7.68808 147.503C11.9341 147.503 15.3762 144.135 15.3762 139.979C15.3762 135.824 11.9341 132.455 7.68808 132.455C3.44207 132.455 0 135.824 0 139.979C0 144.135 3.44207 147.503 7.68808 147.503Z"
          fill="url(#paint1_radial_3694_8732)"
        />
        <path
          d="M69.3199 137.406H27.938C26.5183 137.406 25.3633 136.251 25.3633 134.832C25.3633 133.413 26.5183 132.258 27.938 132.258H69.3199C70.7396 132.258 71.8946 133.413 71.8946 134.832C71.8946 136.251 70.7396 137.406 69.3199 137.406Z"
          fill="white"
        />
        <path
          d="M79.8961 172.179C84.1421 172.179 87.5842 168.811 87.5842 164.655C87.5842 160.5 84.1421 157.131 79.8961 157.131C75.6501 157.131 72.208 160.5 72.208 164.655C72.208 168.811 75.6501 172.179 79.8961 172.179Z"
          fill="url(#paint2_radial_3694_8732)"
        />
        <path
          d="M173.823 170.793H100.146C98.7268 170.793 97.5718 169.638 97.5718 168.219C97.5718 166.799 98.7268 165.645 100.146 165.645H173.823C175.243 165.645 176.398 166.799 176.398 168.219C176.398 169.638 175.243 170.793 173.823 170.793Z"
          fill="white"
        />
        <path
          d="M155.621 31.4898C159.867 31.4898 163.309 28.1211 163.309 23.9656C163.309 19.8101 159.867 16.4414 155.621 16.4414C151.375 16.4414 147.933 19.8101 147.933 23.9656C147.933 28.1211 151.375 31.4898 155.621 31.4898Z"
          fill="url(#paint3_radial_3694_8732)"
        />
        <path
          d="M297.135 157.628C301.381 157.628 304.823 154.26 304.823 150.104C304.823 145.949 301.381 142.58 297.135 142.58C292.889 142.58 289.447 145.949 289.447 150.104C289.447 154.26 292.889 157.628 297.135 157.628Z"
          fill="url(#paint4_radial_3694_8732)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3694_8732"
          x="112.303"
          y="3.50586"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter1_d_3694_8732"
          x="123.406"
          y="8.43945"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter2_d_3694_8732"
          x="244.927"
          y="123.146"
          width="69.9966"
          height="67.0332"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <filter
          id="filter3_d_3694_8732"
          x="136.74"
          y="-6"
          width="179.114"
          height="306.086"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3694_8732" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3694_8732" result="shape" />
        </filter>
        <radialGradient
          id="paint0_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.2193 99.2898) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.68808 139.979) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(79.8961 164.655) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(155.621 23.9656) rotate(90) scale(7.52419 7.68808)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_3694_8732"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(297.135 150.104) rotate(90) scale(7.52419 7.68807)"
        >
          <stop stop-color="#5766BD" />
          <stop offset="1" stop-color="#2F3A79" />
        </radialGradient>
        <clipPath id="clip0_3694_8732">
          <rect width="345" height="287" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FilterIcon = () => (
  <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 1H1V3.89453C1 4.18512 1.11156 4.47593 1.31131 4.6771L7.06369 10.7347C7.26344 10.9358 7.375 11.2266 7.375 11.5172V16.6471L11.625 20V11.5172C11.625 11.2266 11.7366 10.9358 11.9363 10.7347L17.6887 4.6771C17.7875 4.57509 17.866 4.45346 17.9194 4.31911C17.9729 4.18475 18.0003 4.04018 18 3.89453V1Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FullScreenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-arrows-angle-expand"
    viewBox="0 0 16 16"
  >
    <path
      fill-rule="evenodd"
      d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
    />
  </svg>
);

export const FullScreenExitIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-arrows-angle-contract"
    viewBox="0 0 16 16"
  >
    <path
      fill-rule="evenodd"
      d="M.172 15.828a.5.5 0 0 0 .707 0l4.096-4.096V14.5a.5.5 0 1 0 1 0v-3.975a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0 0 1h2.768L.172 15.121a.5.5 0 0 0 0 .707M15.828.172a.5.5 0 0 0-.707 0l-4.096 4.096V1.5a.5.5 0 1 0-1 0v3.975a.5.5 0 0 0 .5.5H14.5a.5.5 0 0 0 0-1h-2.768L15.828.879a.5.5 0 0 0 0-.707"
    />
  </svg>
);

export const VolumeMuteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-volume-mute"
    viewBox="0 0 16 16"
  >
    <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06M6 5.04 4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96zm7.854.606a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0" />
  </svg>
);

export const VolumeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-volume-up"
    viewBox="0 0 16 16"
  >
    <path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z" />
    <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z" />
    <path d="M10.025 8a4.5 4.5 0 0 1-1.318 3.182L8 10.475A3.5 3.5 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.5 4.5 0 0 1 10.025 8M7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12zM4.312 6.39 6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11" />
  </svg>
);

export const ThumbIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-hand-index-thumb"
    viewBox="0 0 16 16"
  >
    <path d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1M8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5 5 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.6 2.6 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046zm2.094 2.025" />
  </svg>
);

export const ThemeAddIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
      <path
        d="M16.5125 32.952C15.5738 32.952 14.8485 32.696 14.3365 32.184C13.8245 31.6293 13.5685 30.8827 13.5685 29.944V19.448H3.2645C2.3685 19.448 1.6645 19.2133 1.1525 18.744C0.6405 18.232 0.3845 17.528 0.3845 16.632C0.3845 15.736 0.6405 15.0533 1.1525 14.584C1.6645 14.072 2.3685 13.816 3.2645 13.816H13.5685V3.64C13.5685 2.70133 13.8245 1.976 14.3365 1.464C14.8485 0.951998 15.5952 0.695999 16.5765 0.695999C17.5152 0.695999 18.2192 0.951998 18.6885 1.464C19.2005 1.976 19.4565 2.70133 19.4565 3.64V13.816H29.7605C30.6992 13.816 31.4032 14.072 31.8725 14.584C32.3845 15.0533 32.6405 15.736 32.6405 16.632C32.6405 17.528 32.3845 18.232 31.8725 18.744C31.4032 19.2133 30.6992 19.448 29.7605 19.448H19.4565V29.944C19.4565 30.8827 19.2005 31.6293 18.6885 32.184C18.2192 32.696 17.4938 32.952 16.5125 32.952Z"
        fill="url(#paint0_linear_101_935)"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_101_935"
          x1="35"
          y1="-0.285714"
          x2="0.813557"
          y2="36.6072"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CA373C" stop-opacity="0.4"></stop>
          <stop offset="1" stop-color="#2F3A79" stop-opacity="0.5"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22V12M12 12V2M12 12H2M12 12H22"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36.647" height="37.358" viewBox="0 0 36.647 37.358">
      <g id="Group_6362" data-name="Group 6362" transform="translate(0.05 0.05)">
        <path
          id="Path_91"
          data-name="Path 91"
          d="M1,30.392v7.6A15.567,15.567,0,0,0,1.2,40.455a11,11,0,0,0,1.43,4.066,8.254,8.254,0,0,0,1.219,1.653A10.887,10.887,0,0,0,11.837,49.1h14.85a10.84,10.84,0,0,0,7.977-2.926A8.251,8.251,0,0,0,35.9,44.521a11.3,11.3,0,0,0,1.462-4.066,17.749,17.749,0,0,0,.179-2.463V28.207a16.207,16.207,0,0,0-.8-5.521,7.406,7.406,0,0,0-1.332-2.364,5.3,5.3,0,0,0-.6-.612,9.409,9.409,0,0,0-6.629-2.05H22.7a4.408,4.408,0,0,1-3.344-1.652l-1.771-2.5a4.293,4.293,0,0,0-3.444-1.653h-3.8C3.518,11.86,1,15.943,1,22.885v7.5S1,30.391,1,30.392Z"
          transform="translate(-1 -11.859)"
          fill="#E8A809"
          stroke="#fff"
          strokeWidth="0.1"
          fillRule="evenodd"
        ></path>
        <g id="Group_505" data-name="Group 505" transform="translate(4.152 24.247)">
          <path
            id="Path_70"
            data-name="Path 70"
            d="M44.125,72.84H19.983a2.018,2.018,0,0,1,0-4.036H44.317a1.867,1.867,0,0,1,1.493.781,1.843,1.843,0,0,1,.427,1.3A2.033,2.033,0,0,1,45.6,72.3a1.964,1.964,0,0,1-1.435.537Z"
            transform="translate(-18 -68.805)"
            fill="#fff"
          ></path>
          <path
            id="Path_71"
            data-name="Path 71"
            d="M45.8,69.737l0,0,0,0a1.722,1.722,0,0,1,.4,1.216h0v0a1.912,1.912,0,0,1-.6,1.332,1.847,1.847,0,0,1-1.35.5H20.066a1.9,1.9,0,0,1,0-3.8H44.4A1.75,1.75,0,0,1,45.8,69.737Z"
            transform="translate(-18.083 -68.885)"
            fill="none"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const GenerateIcon = () => {
  return (
    <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.18912 9.91771C5.38666 9.80366 5.61231 9.73832 5.85934 9.7256L25.7115 8.53042C26.2918 8.49489 26.811 8.7724 27.1031 9.27845C27.3953 9.78447 27.3747 10.3737 27.0552 10.8576L16.094 27.4526C15.9595 27.6601 15.7901 27.8229 15.5925 27.9369C15.1974 28.165 14.6951 28.1917 14.2495 28.0105C13.9467 27.8859 13.553 27.6135 13.3923 27.0226L11.7309 20.9297L17.5638 17.562C18.7098 16.9004 19.1038 15.4299 18.4422 14.2839C17.7805 13.1379 16.3101 12.7439 15.164 13.4055L9.33112 16.7732L4.8852 12.2879C4.45383 11.8532 4.41548 11.3774 4.45822 11.0515C4.52141 10.5766 4.7957 10.1549 5.19347 9.92525M4.38888 8.53165C2.73685 9.48545 2.22794 11.8756 3.74492 13.4063L9.0601 18.766L15.9633 14.7804C16.3449 14.5601 16.8357 14.6916 17.056 15.0732C17.2763 15.4547 17.1448 15.9456 16.7632 16.1659L9.86002 20.1515L11.8441 27.4344C12.4089 29.5095 14.7356 30.2678 16.3876 29.314C16.7827 29.0859 17.1416 28.7578 17.4252 28.3271L28.3863 11.7322C29.7954 9.59813 28.165 6.77429 25.6124 6.92765L5.76106 8.12743C5.24767 8.15685 4.78266 8.30445 4.38756 8.53256L4.38888 8.53165Z"
        fill="white"
      />
      <path
        d="M16.9042 1.90838C16.9304 1.68338 17.2571 1.68338 17.2833 1.90838C17.3812 2.75058 18.0232 3.4271 18.8591 3.56895L18.9298 3.58095C19.1522 3.6187 19.1522 3.93825 18.9298 3.97599L18.8591 3.98799C18.0232 4.12985 17.3812 4.80637 17.2833 5.64857C17.2571 5.87356 16.9304 5.87356 16.9042 5.64857C16.8063 4.80637 16.1643 4.12985 15.3284 3.98799L15.2577 3.97599C15.0353 3.93825 15.0353 3.6187 15.2577 3.58095L15.3284 3.56895C16.1643 3.4271 16.8063 2.75058 16.9042 1.90838Z"
        fill="white"
      />
      <path
        d="M4.77354 19.1113C4.81665 18.7298 5.37085 18.7298 5.41396 19.1113C5.57462 20.5325 6.65293 21.6779 8.06197 21.9238L8.18268 21.9449C8.55653 22.0101 8.55653 22.5468 8.18268 22.612L8.06197 22.6331C6.65292 22.879 5.57462 24.0243 5.41396 25.4456C5.37085 25.827 4.81665 25.827 4.77354 25.4456C4.61288 24.0243 3.53457 22.879 2.12553 22.6331L2.00482 22.612C1.63097 22.5468 1.63097 22.0101 2.00482 21.9449L2.12553 21.9238C3.53458 21.6779 4.61288 20.5325 4.77354 19.1113Z"
        fill="white"
      />
      <path
        d="M16.9042 19.9083C16.9304 19.6834 17.2571 19.6834 17.2833 19.9083C17.3812 20.7505 18.0232 21.4271 18.8591 21.5689L18.9298 21.5809C19.1522 21.6187 19.1522 21.9382 18.9298 21.976L18.8591 21.988C18.0232 22.1298 17.3812 22.8063 17.2833 23.6485C17.2571 23.8735 16.9304 23.8735 16.9042 23.6485C16.8063 22.8063 16.1643 22.1298 15.3284 21.988L15.2577 21.976C15.0353 21.9382 15.0353 21.6187 15.2577 21.5809L15.3284 21.5689C16.1643 21.4271 16.8063 20.7505 16.9042 19.9083Z"
        fill="white"
      />
    </svg>
  );
};

export const DropdownIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    </svg>
  );
};

export const ColorStarsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.35001 15.3999V16.75V15.3999ZM2.35001 16.75V18.1001V16.75ZM2.35001 16.75H3.7H2.35001ZM2.35001 16.75H1H2.35001ZM10.9 1L11.22 3.52002C11.4157 5.06751 12.1096 6.50924 13.1968 7.62769C14.2841 8.74614 15.7057 9.48054 17.247 9.71997L19 10L17.247 10.28C15.7057 10.5195 14.2841 11.2539 13.1968 12.3723C12.1096 13.4908 11.4157 14.9325 11.22 16.48L10.9 19L10.58 16.48C10.3843 14.9325 9.69041 13.4908 8.60316 12.3723C7.51592 11.2539 6.09432 10.5195 4.55299 10.28L2.8 10L4.55299 9.71997C6.09432 9.48054 7.51592 8.74614 8.60316 7.62769C9.69041 6.50924 10.3843 5.06751 10.58 3.52002L10.9 1ZM3.7 1L3.767 1.40991C3.85945 1.96602 4.12377 2.47927 4.52284 2.87744C4.92191 3.27562 5.43569 3.53868 5.992 3.62988L6.39999 3.69995L5.992 3.77002C5.43569 3.86122 4.92191 4.12429 4.52284 4.52246C4.12377 4.92064 3.85945 5.43388 3.767 5.98999L3.7 6.3999L3.633 5.98999C3.54054 5.43388 3.27622 4.92064 2.87715 4.52246C2.47808 4.12429 1.96431 3.86122 1.408 3.77002L1 3.69995L1.408 3.62988C1.96431 3.53868 2.47808 3.27562 2.87715 2.87744C3.27622 2.47927 3.54054 1.96602 3.633 1.40991L3.7 1Z"
        fill="url(#paint0_linear_29_350)"
      />
      <path
        d="M2.35001 15.3999V16.75M2.35001 16.75V18.1001M2.35001 16.75H3.7M2.35001 16.75H1M10.9 1L11.22 3.52002C11.4157 5.06751 12.1096 6.50924 13.1968 7.62769C14.2841 8.74614 15.7057 9.48054 17.247 9.71997L19 10L17.247 10.28C15.7057 10.5195 14.2841 11.2539 13.1968 12.3723C12.1096 13.4908 11.4157 14.9325 11.22 16.48L10.9 19L10.58 16.48C10.3843 14.9325 9.69041 13.4908 8.60316 12.3723C7.51592 11.2539 6.09432 10.5195 4.55299 10.28L2.8 10L4.55299 9.71997C6.09432 9.48054 7.51592 8.74614 8.60316 7.62769C9.69041 6.50924 10.3843 5.06751 10.58 3.52002L10.9 1ZM3.7 1L3.767 1.40991C3.85945 1.96602 4.12377 2.47927 4.52284 2.87744C4.92191 3.27562 5.43569 3.53868 5.992 3.62988L6.39999 3.69995L5.992 3.77002C5.43569 3.86122 4.92191 4.12429 4.52284 4.52246C4.12377 4.92064 3.85945 5.43388 3.767 5.98999L3.7 6.3999L3.633 5.98999C3.54054 5.43388 3.27622 4.92064 2.87715 4.52246C2.47808 4.12429 1.96431 3.86122 1.408 3.77002L1 3.69995L1.408 3.62988C1.96431 3.53868 2.47808 3.27562 2.87715 2.87744C3.27622 2.47927 3.54054 1.96602 3.633 1.40991L3.7 1Z"
        stroke="url(#paint1_linear_29_350)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id="paint0_linear_29_350" x1="1" y1="10" x2="19" y2="10" gradientUnits="userSpaceOnUse">
          <stop stop-color="#2F3A79" />
          <stop offset="1" stop-color="#CA373C" />
        </linearGradient>
        <linearGradient id="paint1_linear_29_350" x1="19" y1="10" x2="1" y2="10" gradientUnits="userSpaceOnUse">
          <stop stop-color="#CA373C" />
          <stop offset="1" stop-color="#2F3A79" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const UploadFileIcon = () => {
  return (
    <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 1.06962V2.44001C13 4.45601 13 5.464 13.3924 6.2344C13.7378 6.91156 14.2884 7.4622 14.9656 7.80761C15.736 8.20001 16.744 8.2 18.76 8.2H20.1304M13 1.06962C12.5272 1.00002 11.9632 1 11.0188 1H8.67999C5.99199 1 4.64801 1.00001 3.62081 1.52321C2.71723 1.98278 1.98278 2.71721 1.52321 3.62079C1.00001 4.64799 1 5.99199 1 8.67999V17.32C1 20.008 1.00001 21.352 1.52321 22.3792C1.98312 23.2825 2.71747 24.0169 3.62081 24.4768C4.64801 25 5.99199 25 8.67999 25H12.52C15.208 25 16.552 25 17.5792 24.4768C18.4823 24.0165 19.2165 23.2823 19.6768 22.3792C20.2 21.352 20.2 20.008 20.2 17.32V10.1812C20.2 9.2368 20.2 8.6728 20.1304 8.2M13 1.06962C13.1152 1.08642 13.2244 1.10679 13.3324 1.13319C13.822 1.25079 14.29 1.44399 14.7196 1.70679C15.2044 2.00439 15.6196 2.4196 16.45 3.25L17.95 4.75C18.7804 5.5804 19.1956 5.99558 19.4932 6.48038C19.756 6.90998 19.9492 7.37799 20.0668 7.86759C20.0932 7.97559 20.1136 8.0848 20.1304 8.2M10.6 19V11.8M10.6 11.8C10.4707 11.8 10.3452 11.8445 10.2448 11.926C9.4784 12.5467 8.7916 13.2597 8.2 14.0488M10.6 11.8C10.7293 11.8 10.8548 11.8445 10.9552 11.926C11.7216 12.5467 12.4084 13.2597 13 14.0488"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StarsIcon = () => {
  return (
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1386 1.75491C19.1648 1.52991 19.4915 1.52991 19.5176 1.75491C19.6155 2.59711 20.2575 3.27363 21.0935 3.41548L21.1642 3.42748C21.3866 3.46523 21.3866 3.78477 21.1642 3.82252L21.0935 3.83452C20.2575 3.97637 19.6155 4.65289 19.5176 5.49509C19.4915 5.72009 19.1648 5.72009 19.1386 5.49509C19.0407 4.65289 18.3987 3.97637 17.5628 3.83452L17.4921 3.82252C17.2696 3.78477 17.2696 3.46523 17.4921 3.42748L17.5628 3.41548C18.3987 3.27363 19.0407 2.59711 19.1386 1.75491Z"
        fill="white"
      />
      <path
        d="M7.69156 6.12421C7.75623 5.5521 8.58752 5.5521 8.65219 6.12421C8.89318 8.25616 10.5106 9.97412 12.6242 10.343L12.8053 10.3746C13.3661 10.4725 13.3661 11.2775 12.8053 11.3754L12.6242 11.407C10.5106 11.7759 8.89318 13.4938 8.65219 15.6258C8.58752 16.1979 7.75623 16.1979 7.69156 15.6258C7.45057 13.4938 5.83311 11.7759 3.71954 11.407L3.53848 11.3754C2.9777 11.2775 2.9777 10.4725 3.53848 10.3746L3.71954 10.343C5.83311 9.97412 7.45057 8.25616 7.69156 6.12421Z"
        fill="white"
      />
      <path
        d="M19.1386 14.0049C19.1648 13.7799 19.4915 13.7799 19.5176 14.0049C19.6155 14.8471 20.2575 15.5236 21.0935 15.6655L21.1642 15.6775C21.3866 15.7152 21.3866 16.0348 21.1642 16.0725L21.0935 16.0845C20.2575 16.2264 19.6155 16.9029 19.5176 17.7451C19.4915 17.9701 19.1648 17.9701 19.1386 17.7451C19.0407 16.9029 18.3987 16.2264 17.5628 16.0845L17.4921 16.0725C17.2696 16.0348 17.2696 15.7152 17.4921 15.6775L17.5628 15.6655C18.3987 15.5236 19.0407 14.8471 19.1386 14.0049Z"
        fill="white"
      />
    </svg>
  );
};

export const CrossIcon = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.85547 17.4167L9.85547 9.41666M9.85547 9.41666L17.8555 1.41666M9.85547 9.41666L1.85547 1.41666M9.85547 9.41666L17.8555 17.4167"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M8.75 2.25C5.16015 2.25 2.25 5.16015 2.25 8.75C2.25 12.3399 5.16015 15.25 8.75 15.25C12.3399 15.25 15.25 12.3399 15.25 8.75C15.25 5.16015 12.3399 2.25 8.75 2.25ZM0.25 8.75C0.25 4.05558 4.05558 0.25 8.75 0.25C13.4444 0.25 17.25 4.05558 17.25 8.75C17.25 10.7369 16.5683 12.5645 15.426 14.0118L19.4571 18.0429C19.8476 18.4334 19.8476 19.0666 19.4571 19.4571C19.0666 19.8476 18.4334 19.8476 18.0429 19.4571L14.0118 15.426C12.5645 16.5683 10.7369 17.25 8.75 17.25C4.05558 17.25 0.25 13.4444 0.25 8.75Z"
        fill="black"
      />
    </svg>
  );
};

export const SearchIconMobile = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
      <g id="Search_icon" data-name="Search icon" transform="translate(0.001 0)">
        <path
          id="Ellipse_642"
          data-name="Ellipse 642"
          d="M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
          transform="translate(-0.001 0)"
          fill="#333"
        />
        <path
          id="Ellipse_643"
          data-name="Ellipse 643"
          d="M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z"
          transform="translate(15.999 15)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const SearchFilterIconMob = () => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 3.4375H6.44444M6.44444 3.4375C6.44444 4.78625 7.489 5.875 8.77778 5.875H9.55556C10.8443 5.875 11.8889 4.78625 11.8889 3.4375C11.8889 2.08875 10.8443 1 9.55556 1H8.77778C7.489 1 6.44444 2.08875 6.44444 3.4375ZM11.1111 11.5625H15M14.2222 3.4375H15M1 11.5625H3.33333M3.33333 11.5625C3.33333 12.9112 4.37789 14 5.66667 14H6.44444C7.73322 14 8.77778 12.9112 8.77778 11.5625C8.77778 10.2138 7.73322 9.125 6.44444 9.125H5.66667C4.37789 9.125 3.33333 10.2138 3.33333 11.5625Z"
        stroke="#363636"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SideToggleIcon = () => {
  return (
    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M7.85719 2.62912e-07H14.1428C15.2266 -9.73709e-06 16.1007 -1.96546e-05 16.8086 0.0578203C17.5375 0.11737 18.1777 0.24318 18.77 0.54497C19.7108 1.02433 20.4757 1.78924 20.955 2.73005C21.2568 3.32234 21.3826 3.96253 21.4422 4.69138C21.5 5.39925 21.5 6.27339 21.5 7.3572V10.6428C21.5 11.7266 21.5 12.6008 21.4422 13.3086C21.3826 14.0375 21.2568 14.6777 20.955 15.27C20.4757 16.2108 19.7108 16.9757 18.77 17.455C18.1777 17.7568 17.5375 17.8826 16.8086 17.9422C16.1008 18 15.2266 18 14.1428 18H7.85717C6.77339 18 5.89925 18 5.19138 17.9422C4.46253 17.8826 3.82234 17.7568 3.23005 17.455C2.28924 16.9757 1.52433 16.2108 1.04497 15.27C0.74318 14.6777 0.61737 14.0375 0.55782 13.3086C0.49998 12.6007 0.49999 11.7266 0.5 10.6428V7.3572C0.49999 6.27341 0.49998 5.39926 0.55782 4.69138C0.61737 3.96253 0.74318 3.32234 1.04497 2.73005C1.52433 1.78924 2.28924 1.02433 3.23005 0.54497C3.82234 0.24318 4.46253 0.11737 5.19138 0.0578203C5.89926 -1.96546e-05 6.77341 -9.73709e-06 7.85719 2.62912e-07ZM5.35424 2.05118C4.74907 2.10062 4.40138 2.19279 4.13803 2.32698C3.57354 2.6146 3.1146 3.07354 2.82698 3.63803C2.69279 3.90138 2.60062 4.24907 2.55118 4.85424C2.50078 5.47108 2.5 6.26339 2.5 7.4V10.6C2.5 11.7366 2.50078 12.5289 2.55118 13.1458C2.60062 13.7509 2.69279 14.0986 2.82698 14.362C3.1146 14.9265 3.57354 15.3854 4.13803 15.673C4.40138 15.8072 4.74907 15.8994 5.35424 15.9488C5.97108 15.9992 6.76339 16 7.9 16H8.5V2H7.9C6.76339 2 5.97108 2.00078 5.35424 2.05118ZM10.5 2V16H14.1C15.2366 16 16.0289 15.9992 16.6458 15.9488C17.2509 15.8994 17.5986 15.8072 17.862 15.673C18.4265 15.3854 18.8854 14.9265 19.173 14.362C19.3072 14.0986 19.3994 13.7509 19.4488 13.1458C19.4992 12.5289 19.5 11.7366 19.5 10.6V7.4C19.5 6.26339 19.4992 5.47108 19.4488 4.85424C19.3994 4.24907 19.3072 3.90138 19.173 3.63803C18.8854 3.07354 18.4265 2.6146 17.862 2.32698C17.5986 2.19279 17.2509 2.10062 16.6458 2.05118C16.0289 2.00078 15.2366 2 14.1 2H10.5ZM4 5.5C4 4.94772 4.44772 4.5 5 4.5H6C6.55229 4.5 7 4.94772 7 5.5C7 6.05229 6.55229 6.5 6 6.5H5C4.44772 6.5 4 6.05229 4 5.5ZM4 9C4 8.4477 4.44772 8 5 8H6C6.55229 8 7 8.4477 7 9C7 9.5523 6.55229 10 6 10H5C4.44772 10 4 9.5523 4 9Z"
        fill="black"
      />
    </svg>
  );
};

export const Remove = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.24" height="24" viewBox="0 0 20.24 24">
      <g id="Group_4462" data-name="Group 4462" transform="translate(-108.999 -172.003)">
        <g id="trash-can-10416" transform="translate(108.999 172.003)">
          <path
            id="Path_156"
            data-name="Path 156"
            d="M48.776,52.948H38.467a2.343,2.343,0,0,1-2.317-2.228L35.123,32.83a.81.81,0,0,1,.212-.6.777.777,0,0,1,.571-.251h15.43a.779.779,0,0,1,.571.251.812.812,0,0,1,.213.6L51.093,50.72A2.343,2.343,0,0,1,48.776,52.948ZM36.738,33.583l.979,17.043a.759.759,0,0,0,.75.722H48.776a.758.758,0,0,0,.75-.721l.979-17.044Z"
            transform="translate(-33.502 -28.948)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_157"
            data-name="Path 157"
            d="M37.169,33.581H18.5a.8.8,0,0,1,0-1.6H37.17a.8.8,0,0,1,0,1.6Z"
            transform="translate(-17.714 -28.946)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_158"
            data-name="Path 158"
            d="M87.407,4.635H80.226a.792.792,0,0,1-.785-.8V2.344A2.324,2.324,0,0,1,81.74,0h4.153a2.324,2.324,0,0,1,2.3,2.344V3.835A.792.792,0,0,1,87.407,4.635Zm-6.4-1.6h5.611V2.344a.737.737,0,0,0-.729-.744H81.74a.737.737,0,0,0-.729.744v.691Z"
            transform="translate(-73.697)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_159"
            data-name="Path 159"
            d="M156.254,88.019h-.047a.8.8,0,0,1-.737-.846l.647-11.265a.786.786,0,0,1,.829-.752.8.8,0,0,1,.737.845l-.647,11.265A.791.791,0,0,1,156.254,88.019Z"
            transform="translate(-142.648 -68.021)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_160"
            data-name="Path 160"
            d="M75.049,88.02a.791.791,0,0,1-.782-.753L73.62,76a.785.785,0,1,1,1.566-.094l.647,11.265a.8.8,0,0,1-.737.846Z"
            transform="translate(-68.416 -68.022)"
            fill="#ca353b"
          ></path>
          <path
            id="Path_161"
            data-name="Path 161"
            d="M118.8,88.024a.792.792,0,0,1-.785-.8V75.959a.785.785,0,1,1,1.569,0V87.224A.792.792,0,0,1,118.8,88.024Z"
            transform="translate(-108.685 -68.026)"
            fill="#ca353b"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const Share = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-share-fill"
      viewBox="0 0 16 16"
    >
      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5"></path>
    </svg>
  );
};

export const SafteyTag = () => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.30273 3.60549L7.85576 1.96159C8.41231 1.76044 9.0217 1.76044 9.57825 1.96159L14.1972 3.62999C14.6565 3.79569 15.0582 4.09049 15.354 4.47896C15.6498 4.86743 15.8272 5.33305 15.8648 5.81988L16.0566 8.31404C16.1944 10.1048 15.8104 11.8972 14.9511 13.4744C14.0918 15.0516 12.794 16.346 11.2145 17.2012L9.9569 17.8833C9.5778 18.0886 9.15263 18.1939 8.72153 18.1891C8.29044 18.1844 7.86767 18.0698 7.49317 17.8562L6.20764 17.1235C4.72985 16.2808 3.51159 15.0488 2.68553 13.5616C1.85947 12.0745 1.45728 10.3892 1.52276 8.6893L1.6301 5.89342C1.64952 5.38889 1.81907 4.90163 2.11705 4.49403C2.41503 4.08644 2.82788 3.77706 3.30273 3.60549Z"
        stroke="#35AE47"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ColorFileIcon = () => {
  return (
    <svg width="73" height="86" viewBox="0 0 73 86" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M46.125 3.22822V7.55981C46.125 13.9438 46.125 17.1359 47.3717 19.5679C48.4535 21.7226 50.2073 23.4696 52.3699 24.5462C54.8175 25.8002 58.02 25.8 64.425 25.8H68.7789M46.125 3.22822C44.6229 3.00022 42.831 3 39.8306 3H32.4C23.86 3 19.59 2.99978 16.3265 4.67178C13.4557 6.11578 11.1225 8.4342 9.66227 11.2842C8.00002 14.5522 8 18.8081 8 27.3201V54.6799C8 63.1919 8.00002 67.4478 9.66227 70.7158C11.1225 73.5658 13.4557 75.8842 16.3265 77.3282C19.59 79.0002 23.86 79 32.4 79H44.6C53.14 79 57.41 79.0002 60.6735 77.3282C63.5416 75.8836 65.8752 73.5679 67.3377 70.7158C69 67.4478 69 63.1919 69 54.6799V32.0701C69 29.0681 69 27.282 68.7789 25.8M46.125 3.22822C46.491 3.26622 46.8379 3.34194 47.181 3.41794C48.7365 3.79794 50.2234 4.40587 51.5883 5.24187C53.1286 6.19187 54.4477 7.48398 57.0859 10.106L61.8516 14.894C64.4898 17.516 65.8089 18.8078 66.7544 20.3658C67.7874 22.0238 68.4758 23.8719 68.7789 25.8M38.5 37.2L38.4695 37.9218C38.292 40.6837 37.1118 43.2868 35.1495 45.2448C33.1871 47.2029 30.5768 48.3821 27.806 48.562C27.6382 48.562 27.4476 48.6 27.0625 48.6C27.4476 48.6 27.6382 48.638 27.806 48.638C30.7028 48.8243 33.4199 50.102 35.406 52.2121C37.3921 54.3223 38.4983 57.1067 38.5 60L38.5305 59.2782C38.708 56.5163 39.8882 53.9132 41.8505 51.9552C43.8129 49.9971 46.4232 48.8179 49.194 48.638C49.3618 48.638 49.5524 48.6 49.9375 48.6C49.5524 48.6 49.3618 48.562 49.194 48.562C46.2972 48.3757 43.5801 47.098 41.594 44.9879C39.6079 42.8777 38.5017 40.0933 38.5 37.2Z"
        fill="url(#paint0_linear_367_1529)"
      />
      <g filter="url(#filter0_d_367_1529)">
        <path
          d="M46 3.21112V7.33175C46 13.7158 46 16.9079 47.2467 19.3399C48.3285 21.4945 50.0823 23.2415 52.2449 24.3181C54.6925 25.5721 57.895 25.5719 64.3 25.5719H68.7378M46 3.21112C46.2569 3.21112 48.7574 3.5 52 5.5C53.5402 6.45 54.3617 7.378 57 10L61.5 14.5C63.2734 16.334 65.5 18.5 66.6294 20.1377C67.6624 21.7957 68.4348 23.6438 68.7378 25.5719"
          fill="url(#paint1_linear_367_1529)"
          fill-opacity="0.51"
        />
      </g>
      <path
        d="M57.7217 65.1339C57.9233 64.3224 59.0767 64.3224 59.2783 65.1339L59.4883 65.9798C60.421 69.7356 63.4621 72.6001 67.2669 73.3067C68.0354 73.4494 68.0354 74.5506 67.2669 74.6933C63.4621 75.3999 60.421 78.2644 59.4883 82.0202L59.2783 82.8661C59.0767 83.6776 57.9233 83.6776 57.7217 82.8661L57.5117 82.0202C56.579 78.2644 53.5379 75.3999 49.7331 74.6933C48.9646 74.5506 48.9646 73.4494 49.7331 73.3067C53.5379 72.6001 56.579 69.7356 57.5117 65.9798L57.7217 65.1339Z"
        fill="url(#paint2_linear_367_1529)"
      />
      <path
        opacity="0.6"
        d="M7.52148 37.9805C7.64283 37.4783 8.35717 37.4783 8.47852 37.9805L8.59424 38.4595C9.16901 40.8383 11.1013 42.6489 13.5125 43.0678C13.9973 43.152 13.9973 43.848 13.5125 43.9322C11.1013 44.3511 9.16901 46.1617 8.59424 48.5405L8.47852 49.0195C8.35717 49.5217 7.64283 49.5217 7.52148 49.0195L7.40576 48.5405C6.83099 46.1617 4.89867 44.3511 2.48748 43.9322C2.00271 43.848 2.00271 43.152 2.48748 43.0678C4.89867 42.6489 6.83099 40.8383 7.40576 38.4595L7.52148 37.9805Z"
        fill="url(#paint3_linear_367_1529)"
      />
      <path
        d="M38.9609 17.676C39.0347 17.0353 39.9653 17.0353 40.0391 17.676C40.3153 20.0712 42.1385 21.997 44.515 22.4036L44.7168 22.4382C45.3486 22.5463 45.3486 23.4537 44.7168 23.5618L44.515 23.5964C42.1385 24.003 40.3153 25.9288 40.0391 28.324C39.9653 28.9647 39.0347 28.9647 38.9609 28.324C38.6847 25.9288 36.8615 24.003 34.485 23.5964L34.2832 23.5618C33.6514 23.4537 33.6514 22.5463 34.2832 22.4382L34.485 22.4036C36.8615 21.997 38.6847 20.0712 38.9609 17.676Z"
        fill="url(#paint4_linear_367_1529)"
      />
      <path
        d="M22 43H56M22 65H43.25M22 53H56"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_367_1529"
          x="40"
          y="0.211121"
          width="32.7379"
          height="32.3608"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_367_1529" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_367_1529" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_367_1529" x1="8" y1="41" x2="69" y2="41" gradientUnits="userSpaceOnUse">
          <stop stop-color="#2F3A79" />
          <stop offset="1" stop-color="#CA373C" />
        </linearGradient>
        <linearGradient id="paint1_linear_367_1529" x1="53.5" y1="15" x2="57" y2="11.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#2F3A79" />
          <stop offset="1" stop-color="#576BDF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_367_1529"
          x1="58.5"
          y1="61.6129"
          x2="58.5"
          y2="86.3871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CDFF3D" />
          <stop offset="0.22" stop-color="white" />
          <stop offset="1" stop-color="#FF9900" />
        </linearGradient>
        <linearGradient id="paint3_linear_367_1529" x1="8" y1="36" x2="8" y2="51" gradientUnits="userSpaceOnUse">
          <stop stop-color="#CDFF3D" />
          <stop offset="0.22" stop-color="white" />
          <stop offset="1" stop-color="#FF9900" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_367_1529"
          x1="39.5"
          y1="14.4286"
          x2="39.5"
          y2="31.5714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CDFF3D" />
          <stop offset="0.22" stop-color="white" />
          <stop offset="1" stop-color="#FF9900" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 2.1C9.1875 2.1 10.2708 2.39167 11.25 2.975C12.2292 3.5375 13.0208 4.32917 13.625 5.35C14.2083 6.37083 14.5 7.45417 14.5 8.6C14.5 9.74583 14.2083 10.8292 13.625 11.85C13.0208 12.8708 12.2292 13.6625 11.25 14.225C10.2708 14.8083 9.1875 15.1 8 15.1C6.8125 15.1 5.72917 14.8083 4.75 14.225C3.77083 13.6625 2.97917 12.8708 2.375 11.85C1.79167 10.8292 1.5 9.74583 1.5 8.6C1.5 7.45417 1.79167 6.37083 2.375 5.35C2.97917 4.32917 3.77083 3.5375 4.75 2.975C5.72917 2.39167 6.8125 2.1 8 2.1ZM8 16.6C9.45833 16.5792 10.7917 16.225 12 15.5375C13.2083 14.8292 14.1875 13.85 14.9375 12.6C15.6458 11.3292 16 9.99583 16 8.6C16 7.20417 15.6458 5.87083 14.9375 4.6C14.1875 3.35 13.2083 2.37083 12 1.6625C10.7917 0.974998 9.45833 0.620831 8 0.599998C6.54167 0.620831 5.20833 0.974998 4 1.6625C2.79167 2.37083 1.8125 3.35 1.0625 4.6C0.354167 5.87083 0 7.20417 0 8.6C0 9.99583 0.354167 11.3292 1.0625 12.6C1.8125 13.85 2.79167 14.8292 4 15.5375C5.20833 16.225 6.54167 16.5792 8 16.6ZM6.75 11.1C6.29167 11.1417 6.04167 11.3917 6 11.85C6.04167 12.3083 6.29167 12.5583 6.75 12.6H9.25C9.70833 12.5583 9.95833 12.3083 10 11.85C9.95833 11.3917 9.70833 11.1417 9.25 11.1H9V8.35C8.95833 7.89167 8.70833 7.64167 8.25 7.6H6.75C6.29167 7.64167 6.04167 7.89167 6 8.35C6.04167 8.80833 6.29167 9.05833 6.75 9.1H7.5V11.1H6.75ZM8 6.6C8.29167 6.6 8.53125 6.50625 8.71875 6.31875C8.90625 6.13125 9 5.89167 9 5.6C9 5.30833 8.90625 5.06875 8.71875 4.88125C8.53125 4.69375 8.29167 4.6 8 4.6C7.70833 4.6 7.46875 4.69375 7.28125 4.88125C7.09375 5.06875 7 5.30833 7 5.6C7 5.89167 7.09375 6.13125 7.28125 6.31875C7.46875 6.50625 7.70833 6.6 8 6.6Z"
        fill="#2A2239"
      />
    </svg>
  );
};

export const StarLineIcon = () => {
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.09382 5.42763L9.00007 1.46124L10.9063 5.42763C11.073 5.73994 11.323 5.92733 11.6563 5.98979L15.9688 6.61442L12.8438 9.70633C12.6147 9.93536 12.5209 10.2269 12.5626 10.5808L13.3126 14.922L9.46882 12.8919C9.15632 12.7254 8.84382 12.7254 8.53132 12.8919L4.68757 14.922L5.43757 10.5808C5.47924 10.2269 5.38549 9.93536 5.15632 9.70633L2.03132 6.61442L6.31257 5.98979C6.66674 5.92733 6.92715 5.73994 7.09382 5.42763ZM13.2813 16.0463C13.5522 16.1921 13.8126 16.1712 14.0626 15.9838C14.3126 15.7965 14.4167 15.557 14.3751 15.2655L13.5626 10.3934L17.0313 6.95797C17.2397 6.74976 17.3022 6.49991 17.2188 6.20842C17.1147 5.91692 16.9063 5.73994 16.5938 5.67748L11.8126 4.99039L9.68757 0.586762C9.54174 0.316091 9.31257 0.170344 9.00007 0.149523C8.68757 0.170344 8.4584 0.316091 8.31257 0.586762L6.18757 4.99039L1.40632 5.70871C1.09382 5.75035 0.885486 5.91692 0.78132 6.20842C0.697986 6.49991 0.760486 6.74976 0.96882 6.95797L4.43757 10.3934L3.62507 15.2655C3.5834 15.557 3.68757 15.7965 3.93757 15.9838C4.18757 16.1712 4.44799 16.1921 4.71882 16.0463L9.00007 13.7664L13.2813 16.0463Z"
        fill="black"
        fill-opacity="0.75"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 8C19 10 15.5 15 10 15C4.5 15 1 10 1 8C1 6 4.5 1 10 1C15.5 1 19 6 19 8Z"
        stroke="#25283D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 8C13 8.79565 12.6839 9.55873 12.1213 10.1213C11.5587 10.6839 10.7956 11 10 11C9.20435 11 8.44129 10.6839 7.87868 10.1213C7.31607 9.55873 7 8.79565 7 8C7 7.20435 7.31607 6.44127 7.87868 5.87866C8.44129 5.31605 9.20435 5 10 5C10.7956 5 11.5587 5.31605 12.1213 5.87866C12.6839 6.44127 13 7.20435 13 8Z"
        stroke="#25283D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SortAZIcon = () => {
  return (
    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 10.9544H23M12 18.4886H23M12 3.42012H23M1 8.44294V5.05229C1 3.30686 2.03523 1.73764 3.61434 1.08468C3.89823 0.971774 4.21288 0.971774 4.49677 1.08468C5.26813 1.40263 5.92928 1.95025 6.39517 2.65738C6.86106 3.3645 7.1104 4.19839 7.11111 5.05229V8.44294M1 5.93153H7.11111M1 14.7215L1.12956 14.6963C3.06062 14.2945 5.05049 14.2945 6.98155 14.6963C7.03655 14.7089 7.05734 14.7718 7.01701 14.822L1.16011 20.8369C1.11244 20.8871 1.15644 20.9623 1.22244 20.9497C3.09244 20.573 5.01866 20.573 6.88866 20.9497L7.11111 21"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SortZAIcon = () => {
  return (
    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 10.5449H23M12 17.925H23M12 3.16484H23M1 21V17.6787C1 15.969 2.03523 14.4319 3.61434 13.7923C3.89822 13.6817 4.21287 13.6817 4.49676 13.7923C5.26812 14.1037 5.92927 14.6401 6.39516 15.3327C6.86104 16.0255 7.11039 16.8423 7.11109 17.6787V21M1 18.54H7.11109M1 1.31983L1.12956 1.2952C3.06061 0.901599 5.05048 0.901599 6.98154 1.2952C7.03654 1.3075 7.05732 1.36913 7.01698 1.41833L1.16011 7.3101C1.11244 7.3593 1.15644 7.43292 1.22244 7.42062C3.09244 7.05162 5.01864 7.05162 6.88864 7.42062L7.11109 7.46987"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const GenFileIcon = () => {
  return (
    <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6011 22.4008H3.3313C2.59571 22.4008 1.99658 21.8417 1.99658 21.1553L1.99798 2.64618C1.99798 1.95972 2.59715 1.40061 3.3327 1.40061H14.1581C14.2551 1.40061 14.3494 1.41242 14.4422 1.42949V4.44697C14.4422 5.54815 15.4028 6.44461 16.5828 6.44461H19.8261C19.8402 6.51549 19.8486 6.58636 19.8486 6.65986V15.153C19.8486 15.5389 20.1833 15.8526 20.5982 15.8526C21.0131 15.8526 21.3479 15.5389 21.3479 15.153V6.65986C21.3479 5.95372 21.0525 5.29223 20.5167 4.79346L16.1636 0.769146C15.6291 0.273003 14.9175 0 14.1594 0H3.33402C1.77146 0 0.5 1.1865 0.5 2.64472V21.1538C0.5 22.612 1.77142 23.7985 3.33402 23.7985H10.6039C11.0188 23.7985 11.3535 23.4848 11.3535 23.099C11.3535 22.7131 11.0188 22.3994 10.6039 22.3994L10.6011 22.4008ZM16.5814 5.04558C16.2283 5.04558 15.9414 4.77783 15.9414 4.4484V2.53738L18.6559 5.04558H16.5814Z"
        fill="black"
      />
      <path
        d="M23.9501 22.0766C20.9529 21.3035 20.4241 20.8114 19.597 18.0157C19.5084 17.7125 19.2117 17.5025 18.8741 17.5025C18.5366 17.5025 18.2398 17.7125 18.1512 18.0157C17.3242 20.8113 16.7954 21.3049 13.7982 22.0766C13.4733 22.1606 13.2482 22.4362 13.2482 22.7513C13.2482 23.0663 13.4733 23.3419 13.7982 23.4259C16.7953 24.199 17.3242 24.6911 18.1512 27.4868C18.2398 27.79 18.5366 28 18.8741 28C19.2117 28 19.5084 27.79 19.597 27.4868C20.424 24.6912 20.9529 24.1976 23.9501 23.4259C24.275 23.3419 24.5 23.0663 24.5 22.7513C24.5 22.4362 24.275 22.1606 23.9501 22.0766ZM18.8741 25.1427C18.303 23.9627 17.5759 23.2855 16.3115 22.7513C17.5759 22.2184 18.303 21.5398 18.8741 20.3598C19.4451 21.5398 20.1722 22.217 21.4366 22.7513C20.1722 23.2841 19.4451 23.9627 18.8741 25.1427Z"
        fill="black"
      />
      <path
        d="M4.99794 5.60068H11.7489C12.1638 5.60068 12.4986 5.28699 12.4986 4.90112C12.4986 4.51526 12.1638 4.20156 11.7489 4.20156H4.99794C4.58305 4.20156 4.2483 4.51525 4.2483 4.90112C4.2483 5.28699 4.58304 5.60068 4.99794 5.60068Z"
        fill="black"
      />
      <path
        d="M16.9993 7.70069H4.99794C4.58305 7.70069 4.2483 8.01438 4.2483 8.40025C4.2483 8.78611 4.58304 9.09981 4.99794 9.09981H16.9993C17.4141 9.09981 17.7489 8.78612 17.7489 8.40025C17.7489 8.01438 17.4141 7.70069 16.9993 7.70069Z"
        fill="black"
      />
      <path
        d="M16.9993 11.2012H4.99794C4.58305 11.2012 4.2483 11.5149 4.2483 11.9007C4.2483 12.2866 4.58304 12.6003 4.99794 12.6003H16.9993C17.4141 12.6003 17.7489 12.2866 17.7489 11.9007C17.7489 11.5149 17.4141 11.2012 16.9993 11.2012Z"
        fill="black"
      />
      <path
        d="M16.9993 14.7003H4.99794C4.58305 14.7003 4.2483 15.014 4.2483 15.3999C4.2483 15.7858 4.58304 16.0994 4.99794 16.0994H16.9993C17.4141 16.0994 17.7489 15.7858 17.7489 15.3999C17.7489 15.014 17.4141 14.7003 16.9993 14.7003Z"
        fill="black"
      />
      <path
        d="M12.4986 18.2008H4.99794C4.58305 18.2008 4.2483 18.5145 4.2483 18.9004C4.2483 19.2862 4.58304 19.5999 4.99794 19.5999H12.4986C12.9135 19.5999 13.2482 19.2862 13.2482 18.9004C13.2482 18.5145 12.9135 18.2008 12.4986 18.2008Z"
        fill="black"
      />
    </svg>
  );
};

export const ShorterIcon = () => {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.98301 5.07549L8.78301 3.27549C9.01634 2.99215 9.01634 2.70882 8.78301 2.42549C8.49967 2.19215 8.21634 2.19215 7.93301 2.42549L7.15801 3.20049V1.05049C7.12467 0.683822 6.92467 0.483822 6.55801 0.450488C6.19134 0.483822 5.99134 0.683822 5.95801 1.05049V3.20049L5.18301 2.42549C4.89967 2.19215 4.61634 2.19215 4.33301 2.42549C4.09967 2.70882 4.09967 2.99215 4.33301 3.27549L6.13301 5.07549C6.41634 5.30882 6.69967 5.30882 6.98301 5.07549ZM0.958008 6.85049C0.958008 7.08382 1.03301 7.27549 1.18301 7.42549C1.33301 7.57549 1.52467 7.65049 1.75801 7.65049C1.99134 7.65049 2.18301 7.57549 2.33301 7.42549C2.48301 7.27549 2.55801 7.08382 2.55801 6.85049C2.55801 6.61716 2.48301 6.42549 2.33301 6.27549C2.18301 6.12549 1.99134 6.05049 1.75801 6.05049C1.52467 6.05049 1.33301 6.12549 1.18301 6.27549C1.03301 6.42549 0.958008 6.61716 0.958008 6.85049ZM3.35801 6.85049C3.35801 7.08382 3.43301 7.27549 3.58301 7.42549C3.73301 7.57549 3.92467 7.65049 4.15801 7.65049C4.39134 7.65049 4.58301 7.57549 4.73301 7.42549C4.88301 7.27549 4.95801 7.08382 4.95801 6.85049C4.95801 6.61716 4.88301 6.42549 4.73301 6.27549C4.58301 6.12549 4.39134 6.05049 4.15801 6.05049C3.92467 6.05049 3.73301 6.12549 3.58301 6.27549C3.43301 6.42549 3.35801 6.61716 3.35801 6.85049ZM6.55801 6.05049C6.32467 6.05049 6.13301 6.12549 5.98301 6.27549C5.83301 6.42549 5.75801 6.61716 5.75801 6.85049C5.75801 7.08382 5.83301 7.27549 5.98301 7.42549C6.13301 7.57549 6.32467 7.65049 6.55801 7.65049C6.79134 7.65049 6.98301 7.57549 7.13301 7.42549C7.28301 7.27549 7.35801 7.08382 7.35801 6.85049C7.35801 6.61716 7.28301 6.42549 7.13301 6.27549C6.98301 6.12549 6.79134 6.05049 6.55801 6.05049ZM8.15801 6.85049C8.15801 7.08382 8.23301 7.27549 8.38301 7.42549C8.53301 7.57549 8.72467 7.65049 8.95801 7.65049C9.19134 7.65049 9.38301 7.57549 9.53301 7.42549C9.68301 7.27549 9.75801 7.08382 9.75801 6.85049C9.75801 6.61716 9.68301 6.42549 9.53301 6.27549C9.38301 6.12549 9.19134 6.05049 8.95801 6.05049C8.72467 6.05049 8.53301 6.12549 8.38301 6.27549C8.23301 6.42549 8.15801 6.61716 8.15801 6.85049ZM11.358 6.05049C11.1247 6.05049 10.933 6.12549 10.783 6.27549C10.633 6.42549 10.558 6.61716 10.558 6.85049C10.558 7.08382 10.633 7.27549 10.783 7.42549C10.933 7.57549 11.1247 7.65049 11.358 7.65049C11.5913 7.65049 11.783 7.57549 11.933 7.42549C12.083 7.27549 12.158 7.08382 12.158 6.85049C12.158 6.61716 12.083 6.42549 11.933 6.27549C11.783 6.12549 11.5913 6.05049 11.358 6.05049ZM8.78301 10.4255L6.98301 8.62549C6.69967 8.39216 6.41634 8.39216 6.13301 8.62549L4.33301 10.4255C4.09967 10.7088 4.09967 10.9922 4.33301 11.2755C4.61634 11.5088 4.89967 11.5088 5.18301 11.2755L5.95801 10.5005V12.6505C5.99134 13.0172 6.19134 13.2172 6.55801 13.2505C6.92467 13.2172 7.12467 13.0172 7.15801 12.6505V10.5005L7.93301 11.2755C8.21634 11.5088 8.49967 11.5088 8.78301 11.2755C9.01634 10.9922 9.01634 10.7088 8.78301 10.4255Z"
        fill="#2A2239"
      />
    </svg>
  );
};

export const LongerIcon = () => {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.98301 0.625488C6.69967 0.392155 6.41634 0.392155 6.13301 0.625488L4.33301 2.42549C4.09967 2.70882 4.09967 2.99216 4.33301 3.27549C4.61634 3.50882 4.89967 3.50882 5.18301 3.27549L5.95801 2.50049V4.65049C5.99134 5.01715 6.19134 5.21715 6.55801 5.25049C6.92467 5.21715 7.12467 5.01715 7.15801 4.65049V2.50049L7.93301 3.27549C8.21634 3.50882 8.49967 3.50882 8.78301 3.27549C9.01634 2.99216 9.01634 2.70882 8.78301 2.42549L6.98301 0.625488ZM7.15801 9.05049C7.12467 8.68382 6.92467 8.48382 6.55801 8.45049C6.19134 8.48382 5.99134 8.68382 5.95801 9.05049V11.2005L5.18301 10.4255C4.89967 10.1922 4.61634 10.1922 4.33301 10.4255C4.09967 10.7088 4.09967 10.9922 4.33301 11.2755L6.13301 13.0755C6.41634 13.3088 6.69967 13.3088 6.98301 13.0755L8.78301 11.2755C9.01634 10.9922 9.01634 10.7088 8.78301 10.4255C8.49967 10.1922 8.21634 10.1922 7.93301 10.4255L7.15801 11.2005V9.05049ZM1.75801 6.05049C1.52467 6.05049 1.33301 6.12549 1.18301 6.27549C1.03301 6.42549 0.958008 6.61716 0.958008 6.85049C0.958008 7.08382 1.03301 7.27549 1.18301 7.42549C1.33301 7.57549 1.52467 7.65049 1.75801 7.65049C1.99134 7.65049 2.18301 7.57549 2.33301 7.42549C2.48301 7.27549 2.55801 7.08382 2.55801 6.85049C2.55801 6.61716 2.48301 6.42549 2.33301 6.27549C2.18301 6.12549 1.99134 6.05049 1.75801 6.05049ZM4.15801 6.05049C3.92467 6.05049 3.73301 6.12549 3.58301 6.27549C3.43301 6.42549 3.35801 6.61716 3.35801 6.85049C3.35801 7.08382 3.43301 7.27549 3.58301 7.42549C3.73301 7.57549 3.92467 7.65049 4.15801 7.65049C4.39134 7.65049 4.58301 7.57549 4.73301 7.42549C4.88301 7.27549 4.95801 7.08382 4.95801 6.85049C4.95801 6.61716 4.88301 6.42549 4.73301 6.27549C4.58301 6.12549 4.39134 6.05049 4.15801 6.05049ZM5.75801 6.85049C5.75801 7.08382 5.83301 7.27549 5.98301 7.42549C6.13301 7.57549 6.32467 7.65049 6.55801 7.65049C6.79134 7.65049 6.98301 7.57549 7.13301 7.42549C7.28301 7.27549 7.35801 7.08382 7.35801 6.85049C7.35801 6.61716 7.28301 6.42549 7.13301 6.27549C6.98301 6.12549 6.79134 6.05049 6.55801 6.05049C6.32467 6.05049 6.13301 6.12549 5.98301 6.27549C5.83301 6.42549 5.75801 6.61716 5.75801 6.85049ZM8.95801 6.05049C8.72467 6.05049 8.53301 6.12549 8.38301 6.27549C8.23301 6.42549 8.15801 6.61716 8.15801 6.85049C8.15801 7.08382 8.23301 7.27549 8.38301 7.42549C8.53301 7.57549 8.72467 7.65049 8.95801 7.65049C9.19134 7.65049 9.38301 7.57549 9.53301 7.42549C9.68301 7.27549 9.75801 7.08382 9.75801 6.85049C9.75801 6.61716 9.68301 6.42549 9.53301 6.27549C9.38301 6.12549 9.19134 6.05049 8.95801 6.05049ZM10.558 6.85049C10.558 7.08382 10.633 7.27549 10.783 7.42549C10.933 7.57549 11.1247 7.65049 11.358 7.65049C11.5913 7.65049 11.783 7.57549 11.933 7.42549C12.083 7.27549 12.158 7.08382 12.158 6.85049C12.158 6.61716 12.083 6.42549 11.933 6.27549C11.783 6.12549 11.5913 6.05049 11.358 6.05049C11.1247 6.05049 10.933 6.12549 10.783 6.27549C10.633 6.42549 10.558 6.61716 10.558 6.85049Z"
        fill="#2A2239"
      />
    </svg>
  );
};

export const ImproveIcon = () => {
  return (
    <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.13623 0.4255C3.41937 0.192167 3.70251 0.192167 3.98565 0.4255L6.38401 2.8255C6.61718 3.10883 6.61718 3.39217 6.38401 3.6755C6.10087 3.90883 5.81773 3.90883 5.53459 3.6755L4.16053 2.3005V10.8505C4.12722 11.2172 3.92735 11.4172 3.56094 11.4505C3.19452 11.4172 2.99466 11.2172 2.96135 10.8505V2.3005L1.58729 3.6755C1.30415 3.90883 1.02101 3.90883 0.737869 3.6755C0.504695 3.39217 0.504695 3.10883 0.737869 2.8255L3.13623 0.4255ZM8.15779 11.4505C7.79138 11.4172 7.59151 11.2172 7.5582 10.8505C7.59151 10.4838 7.79138 10.2838 8.15779 10.2505H9.35697C9.72339 10.2838 9.92325 10.4838 9.95656 10.8505C9.92325 11.2172 9.72339 11.4172 9.35697 11.4505H8.15779ZM8.15779 8.2505C7.79138 8.21717 7.59151 8.01717 7.5582 7.6505C7.59151 7.28383 7.79138 7.08383 8.15779 7.0505H10.9559C11.3223 7.08383 11.5222 7.28383 11.5555 7.6505C11.5222 8.01717 11.3223 8.21717 10.9559 8.2505H8.15779ZM8.15779 5.0505C7.79138 5.01717 7.59151 4.81717 7.5582 4.4505C7.59151 4.08383 7.79138 3.88383 8.15779 3.8505H12.5548C12.9212 3.88383 13.1211 4.08383 13.1544 4.4505C13.1211 4.81717 12.9212 5.01717 12.5548 5.0505H8.15779ZM8.15779 1.8505C7.79138 1.81717 7.59151 1.61717 7.5582 1.2505C7.59151 0.883834 7.79138 0.683834 8.15779 0.6505H14.1537C14.5201 0.683834 14.72 0.883834 14.7533 1.2505C14.72 1.61717 14.5201 1.81717 14.1537 1.8505H8.15779Z"
        fill="#2A2239"
      />
    </svg>
  );
};

export const CircleCrossIcon = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.19971 0.999969C9.47054 1.0208 10.6372 1.3333 11.6997 1.93747C12.7622 2.56247 13.6164 3.41664 14.2622 4.49997C14.8872 5.60414 15.1997 6.7708 15.1997 7.99997C15.1997 9.22914 14.8872 10.3958 14.2622 11.5C13.6164 12.5833 12.7622 13.4375 11.6997 14.0625C10.6372 14.6666 9.47054 14.9791 8.19971 15C6.92887 14.9791 5.76221 14.6666 4.69971 14.0625C3.63721 13.4375 2.78304 12.5833 2.13721 11.5C1.51221 10.3958 1.19971 9.22914 1.19971 7.99997C1.19971 6.7708 1.51221 5.60414 2.13721 4.49997C2.78304 3.41664 3.63721 2.56247 4.69971 1.93747C5.76221 1.3333 6.92887 1.0208 8.19971 0.999969ZM8.19971 16C9.65804 15.9791 10.9914 15.625 12.1997 14.9375C13.408 14.2291 14.3872 13.25 15.1372 12C15.8455 10.7291 16.1997 9.3958 16.1997 7.99997C16.1997 6.60414 15.8455 5.2708 15.1372 3.99997C14.3872 2.74997 13.408 1.7708 12.1997 1.06247C10.9914 0.374969 9.65804 0.0208025 8.19971 -3.05176e-05C6.74137 0.0208025 5.40804 0.374969 4.19971 1.06247C2.99137 1.7708 2.01221 2.74997 1.26221 3.99997C0.553874 5.2708 0.199707 6.60414 0.199707 7.99997C0.199707 9.3958 0.553874 10.7291 1.26221 12C2.01221 13.25 2.99137 14.2291 4.19971 14.9375C5.40804 15.625 6.74137 15.9791 8.19971 16ZM5.85596 5.65622C5.64762 5.88539 5.64762 6.11455 5.85596 6.34372L7.48096 7.99997L5.85596 9.65622C5.64762 9.88539 5.64762 10.1146 5.85596 10.3437C6.08512 10.5521 6.31429 10.5521 6.54346 10.3437L8.19971 8.71872L9.85596 10.3437C10.0851 10.5521 10.3143 10.5521 10.5435 10.3437C10.7518 10.1146 10.7518 9.88539 10.5435 9.65622L8.91846 7.99997L10.5435 6.34372C10.7518 6.11455 10.7518 5.88539 10.5435 5.65622C10.3143 5.44789 10.0851 5.44789 9.85596 5.65622L8.19971 7.28122L6.54346 5.65622C6.31429 5.44789 6.08512 5.44789 5.85596 5.65622Z"
        fill="#2A2239"
      />
    </svg>
  );
};

export const RotateArrowIcon = () => {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0996 4.59998C12.0663 4.96664 11.8663 5.16664 11.4996 5.19998H8.69961H7.89961C7.53294 5.16664 7.33294 4.96664 7.29961 4.59998C7.33294 4.23331 7.53294 4.03331 7.89961 3.99998H8.69961H10.0496L8.74961 2.69998C8.01628 1.98331 7.13294 1.61664 6.09961 1.59998C5.18294 1.61664 4.36628 1.86664 3.64961 2.34998C2.93294 2.83331 2.39961 3.47498 2.04961 4.27498C1.88294 4.60831 1.62461 4.71664 1.27461 4.59998C0.941276 4.41664 0.832943 4.14998 0.949609 3.79998C1.38294 2.78331 2.05794 1.96664 2.97461 1.34998C3.89128 0.733309 4.93294 0.416642 6.09961 0.399976C7.44961 0.416642 8.61628 0.899976 9.59961 1.84998L10.8996 3.14998V1.79998V0.999975C10.9329 0.633308 11.1329 0.433309 11.4996 0.399976C11.8663 0.433309 12.0663 0.633308 12.0996 0.999975V4.59998ZM0.699609 6.79998H3.49961C3.86628 6.83331 4.06628 7.03331 4.09961 7.39998C4.06628 7.76664 3.86628 7.96664 3.49961 7.99998H2.14961L3.44961 9.29998C4.18294 10.0166 5.06628 10.3833 6.09961 10.4C7.01628 10.3833 7.83294 10.1333 8.54961 9.64998C9.26628 9.16664 9.79961 8.52498 10.1496 7.72498C10.3163 7.40831 10.5746 7.30831 10.9246 7.42498C11.2579 7.59164 11.3663 7.84998 11.2496 8.19998C10.7996 9.21664 10.1246 10.0333 9.22461 10.65C8.30794 11.2666 7.26628 11.5833 6.09961 11.6C4.74961 11.5833 3.58294 11.1 2.59961 10.15L1.29961 8.84998V10.2C1.26628 10.5666 1.06628 10.7666 0.699609 10.8C0.332943 10.7666 0.132943 10.5666 0.0996094 10.2V7.39998C0.132943 7.03331 0.332943 6.83331 0.699609 6.79998Z"
        fill="#2A2239"
      />
    </svg>
  );
};

export const MoreIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.6998 12C7.6498 12 8.51647 11.7667 9.2998 11.3C10.0831 10.85 10.7165 10.2167 11.1998 9.40001C11.6665 8.58335 11.8998 7.71668 11.8998 6.80001C11.8998 5.88335 11.6665 5.01668 11.1998 4.20001C10.7165 3.38335 10.0831 2.75001 9.2998 2.30001C8.51647 1.83335 7.6498 1.60001 6.6998 1.60001C5.7498 1.60001 4.88314 1.83335 4.0998 2.30001C3.31647 2.75001 2.68314 3.38335 2.1998 4.20001C1.73314 5.01668 1.4998 5.88335 1.4998 6.80001C1.4998 7.71668 1.73314 8.58335 2.1998 9.40001C2.68314 10.2167 3.31647 10.85 4.0998 11.3C4.88314 11.7667 5.7498 12 6.6998 12ZM6.6998 0.400012C7.86647 0.416678 8.93314 0.700012 9.89981 1.25001C10.8665 1.81668 11.6498 2.60001 12.2498 3.60001C12.8165 4.61668 13.0998 5.68335 13.0998 6.80001C13.0998 7.91668 12.8165 8.98335 12.2498 10C11.6498 11 10.8665 11.7833 9.89981 12.35C8.93314 12.9 7.86647 13.1833 6.6998 13.2C5.53314 13.1833 4.46647 12.9 3.4998 12.35C2.53314 11.7833 1.7498 11 1.1498 10C0.583138 8.98335 0.299805 7.91668 0.299805 6.80001C0.299805 5.68335 0.583138 4.61668 1.1498 3.60001C1.7498 2.60001 2.53314 1.81668 3.4998 1.25001C4.46647 0.700012 5.53314 0.416678 6.6998 0.400012ZM7.4998 6.80001C7.4998 7.03335 7.4248 7.22501 7.2748 7.37501C7.1248 7.52501 6.93314 7.60001 6.6998 7.60001C6.46647 7.60001 6.2748 7.52501 6.1248 7.37501C5.9748 7.22501 5.8998 7.03335 5.8998 6.80001C5.8998 6.56668 5.9748 6.37501 6.1248 6.22501C6.2748 6.07501 6.46647 6.00001 6.6998 6.00001C6.93314 6.00001 7.1248 6.07501 7.2748 6.22501C7.4248 6.37501 7.4998 6.56668 7.4998 6.80001ZM9.0998 6.00001C9.33314 6.00001 9.52481 6.07501 9.6748 6.22501C9.82481 6.37501 9.89981 6.56668 9.89981 6.80001C9.89981 7.03335 9.82481 7.22501 9.6748 7.37501C9.52481 7.52501 9.33314 7.60001 9.0998 7.60001C8.86647 7.60001 8.6748 7.52501 8.52481 7.37501C8.3748 7.22501 8.2998 7.03335 8.2998 6.80001C8.2998 6.56668 8.3748 6.37501 8.52481 6.22501C8.6748 6.07501 8.86647 6.00001 9.0998 6.00001ZM5.0998 6.80001C5.0998 7.03335 5.0248 7.22501 4.8748 7.37501C4.7248 7.52501 4.53314 7.60001 4.2998 7.60001C4.06647 7.60001 3.8748 7.52501 3.7248 7.37501C3.5748 7.22501 3.4998 7.03335 3.4998 6.80001C3.4998 6.56668 3.5748 6.37501 3.7248 6.22501C3.8748 6.07501 4.06647 6.00001 4.2998 6.00001C4.53314 6.00001 4.7248 6.07501 4.8748 6.22501C5.0248 6.37501 5.0998 6.56668 5.0998 6.80001Z"
        fill="#2A2239"
      />
    </svg>
  );
};

// export const CheckIcon = () => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="16"
//       height="16"
//       fill="currentColor"
//       className="bi bi-check2"
//       viewBox="0 0 16 16"
//     >
//       <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
//     </svg>
//   );
// };

export const WalkIcon = () => {
  return (
    <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M13 6C14.1046 6 15 5.10457 15 4C15 2.89543 14.1046 2 13 2C11.8955 2 11 2.89543 11 4C11 5.10457 11.8955 6 13 6ZM11.0528 6.60557C11.3841 6.43992 11.7799 6.47097 12.0813 6.68627L13.0813 7.40056C13.3994 7.6278 13.5559 8.01959 13.482 8.40348L12.4332 13.847L16.8321 20.4453C17.1384 20.9048 17.0143 21.5257 16.5547 21.8321C16.0952 22.1384 15.4743 22.0142 15.168 21.5547L10.5416 14.6152L9.72611 13.3919C9.58336 13.1778 9.52866 12.9169 9.57338 12.6634L10.1699 9.28309L8.38464 10.1757L7.81282 13.0334C7.70445 13.575 7.17759 13.9261 6.63604 13.8178C6.09449 13.7094 5.74333 13.1825 5.85169 12.641L6.51947 9.30379C6.58001 9.00123 6.77684 8.74356 7.05282 8.60557L11.0528 6.60557ZM16.6838 12.9487L13.8093 11.9905L14.1909 10.0096L17.3163 11.0513C17.8402 11.226 18.1234 11.7923 17.9487 12.3162C17.7741 12.8402 17.2078 13.1234 16.6838 12.9487ZM6.12844 20.5097L9.39637 14.7001L9.70958 15.1699L10.641 16.5669L7.87159 21.4903C7.60083 21.9716 6.99111 22.1423 6.50976 21.8716C6.0284 21.6008 5.85768 20.9911 6.12844 20.5097Z"
        fill="#000000"
      />
    </svg>
  );
};
export const CopyLinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-link-45deg"
      viewBox="0 0 16 16"
    >
      <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z" />
      <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z" />
    </svg>
  );
};


export const ViewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-eye"
      viewBox="0 0 16 16"
    >
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
    </svg>
  );
};

export const GlobeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-globe"
      viewBox="0 0 16 16"
    >
      <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" />
    </svg>
  );
};

export const LockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-lock"
      viewBox="0 0 16 16"
    >
      <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
    </svg>
  );
};

export const LinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-box-arrow-up-right"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
      />
      <path
        fill-rule="evenodd"
        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
      />
    </svg>
  );
};

export const PDFPrev = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-filetype-pdf"
    viewBox="0 0 16 16"
  >
    <path
      fill-rule="evenodd"
      d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
    />
  </svg>
);

export const VideoPrev = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-file-play"
    viewBox="0 0 16 16"
  >
    <path d="M6 10.117V5.883a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43z" />
    <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
  </svg>
);

export const MediaCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-check-circle-fill"
    viewBox="0 0 16 16"
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
);

export const AudioPrev = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-file-music"
    viewBox="0 0 16 16"
  >
    <path d="M10.304 3.13a1 1 0 0 1 1.196.98v1.8l-2.5.5v5.09c0 .495-.301.883-.662 1.123C7.974 12.866 7.499 13 7 13s-.974-.134-1.338-.377C5.302 12.383 5 11.995 5 11.5s.301-.883.662-1.123C6.026 10.134 6.501 10 7 10c.356 0 .7.068 1 .196V4.41a1 1 0 0 1 .804-.98z" />
    <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
  </svg>
);

export const StarDefaultIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-star-fill"
    viewBox="0 0 16 16"
  >
    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
  </svg>
);

export const TeamDashboardIcon = () => {
  return (
    <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.90072 5.45321C1.90072 4.06956 1.90073 3.37791 2.15828 2.84669C2.38512 2.38959 2.74663 2.00648 3.19086 1.77175C3.69652 1.49996 4.35813 1.5 5.68135 1.5H6.39022C7.71344 1.5 8.37505 1.49996 8.88071 1.77175C9.32494 2.00648 9.68645 2.38959 9.91329 2.84669C10.1708 3.37791 10.1708 4.06956 10.1708 5.45321V6.19456C10.1708 7.57821 10.1708 8.26986 9.91329 8.80108C9.68645 9.25818 9.32494 9.64129 8.88071 9.87602C8.37505 10.1478 7.71344 10.1478 6.39022 10.1478H5.68135C4.35813 10.1478 3.69652 10.1478 3.19086 9.87602C2.74663 9.64129 2.38512 9.25818 2.15828 8.80108C1.90073 8.26986 1.90072 7.57821 1.90072 6.19456V5.45321ZM2.86124 22.2052C1.92554 21.2293 1.45768 20.7353 1.28283 20.1793C1.12806 19.6852 1.12806 19.1413 1.28283 18.6471C1.45768 18.0912 1.92554 17.5972 2.86124 16.6212L3.36217 16.0901C4.29788 15.1141 4.76573 14.6199 5.30566 14.4469C5.7806 14.2863 6.29097 14.2863 6.76591 14.4469C7.30583 14.6199 7.77369 15.1141 8.7094 16.0901L9.21033 16.6212C10.146 17.5972 10.6139 18.0912 10.7887 18.6471C10.9435 19.1413 10.9435 19.6852 10.7887 20.1793C10.6139 20.7353 10.146 21.2293 9.21033 22.2052L8.7094 22.7364C7.77369 23.7123 7.30583 24.2066 6.76591 24.3795C6.29097 24.5402 5.7806 24.5402 5.30566 24.3795C4.76573 24.2066 4.29788 23.7123 3.36217 22.7364L2.86124 22.2052ZM14.8966 5.82388C14.8966 3.43957 16.748 1.5 19.0317 1.5C21.3154 1.5 23.1667 3.43957 23.1667 5.82388C23.1667 8.2082 21.3154 10.1478 19.0317 10.1478C16.748 10.1478 14.8966 8.2082 14.8966 5.82388ZM14.8966 19.0426C14.8966 17.6589 14.8966 16.9673 15.1542 16.436C15.381 15.9789 15.7425 15.5958 16.1868 15.3611C16.6924 15.0893 17.354 15.0894 18.6773 15.0894H19.3861C20.7093 15.0894 21.371 15.0893 21.8766 15.3611C22.3208 15.5958 22.6824 15.9789 22.9092 16.436C23.1667 16.9673 23.1667 17.6589 23.1667 19.0426V19.7839C23.1667 21.1676 23.1667 21.8592 22.9092 22.3904C22.6824 22.8475 22.3208 23.2306 21.8766 23.4654C21.371 23.7372 20.7093 23.7371 19.3861 23.7371H18.6773C17.354 23.7371 16.6924 23.7372 16.1868 23.4654C15.7425 23.2306 15.381 22.8475 15.1542 22.3904C14.8966 21.8592 14.8966 21.1676 14.8966 19.7839V19.0426Z"
        stroke="#0F0F1C"
        stroke-opacity="0.6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TeamDashboardActive = () => {
  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.1945 22.205C2.25879 21.229 1.79093 20.735 1.61608 20.1791C1.46131 19.6849 1.46131 19.1411 1.61608 18.6469C1.79093 18.091 2.25879 17.597 3.1945 16.621L3.69542 16.0899C4.63113 15.1139 5.09899 14.6196 5.63891 14.4467C6.11385 14.2861 6.62422 14.2861 7.09917 14.4467C7.63909 14.6196 8.10694 15.1139 9.04265 16.0899L9.54358 16.621C10.4793 17.597 10.9471 18.091 11.122 18.6469C11.2768 19.1411 11.2768 19.6849 11.122 20.1791C10.9471 20.735 10.4793 21.229 9.54358 22.205L9.04265 22.7361C8.10694 23.7121 7.63909 24.2064 7.09917 24.3793C6.62422 24.5399 6.11385 24.5399 5.63891 24.3793C5.09899 24.2064 4.63113 23.7121 3.69542 22.7361L3.1945 22.205Z"
        fill="#2F3A79"
      />
      <path
        d="M2.23398 5.45296C2.23398 4.06932 2.23398 3.37767 2.49153 2.84645C2.71837 2.38935 3.07989 2.00623 3.52411 1.77151C4.02977 1.49972 4.69138 1.49976 6.0146 1.49976H6.72347C8.04669 1.49976 8.70831 1.49972 9.21396 1.77151C9.65819 2.00623 10.0197 2.38935 10.2465 2.84645C10.5041 3.37767 10.5041 4.06932 10.5041 5.45296V6.19432C10.5041 7.57796 10.5041 8.26961 10.2465 8.80083C10.0197 9.25793 9.65819 9.64105 9.21396 9.87577C8.70831 10.1476 8.04669 10.1475 6.72347 10.1475H6.0146C4.69138 10.1475 4.02977 10.1476 3.52411 9.87577C3.07989 9.64105 2.71837 9.25793 2.49153 8.80083C2.23398 8.26961 2.23398 7.57796 2.23398 6.19432V5.45296ZM3.1945 22.205C2.25879 21.229 1.79093 20.735 1.61608 20.1791C1.46131 19.6849 1.46131 19.1411 1.61608 18.6469C1.79093 18.091 2.25879 17.5969 3.1945 16.621L3.69542 16.0898C4.63113 15.1139 5.09899 14.6196 5.63891 14.4467C6.11385 14.2861 6.62422 14.2861 7.09917 14.4467C7.63909 14.6196 8.10694 15.1139 9.04265 16.0898L9.54358 16.621C10.4793 17.5969 10.9471 18.091 11.122 18.6469C11.2768 19.1411 11.2768 19.6849 11.122 20.1791C10.9471 20.735 10.4793 21.229 9.54358 22.205L9.04265 22.7361C8.10694 23.7121 7.63909 24.2064 7.09917 24.3793C6.62422 24.5399 6.11385 24.5399 5.63891 24.3793C5.09899 24.2064 4.63113 23.7121 3.69542 22.7361L3.1945 22.205ZM15.2299 5.82364C15.2299 3.43933 17.0812 1.49976 19.3649 1.49976C21.6487 1.49976 23.5 3.43933 23.5 5.82364C23.5 8.20795 21.6487 10.1475 19.3649 10.1475C17.0812 10.1475 15.2299 8.20795 15.2299 5.82364ZM15.2299 19.0423C15.2299 17.6587 15.2299 16.967 15.4874 16.4358C15.7143 15.9787 16.0758 15.5956 16.52 15.3609C17.0257 15.0891 17.6873 15.0891 19.0105 15.0891H19.7194C21.0426 15.0891 21.7042 15.0891 22.2099 15.3609C22.6541 15.5956 23.0156 15.9787 23.2424 16.4358C23.5 16.967 23.5 17.6587 23.5 19.0423V19.7837C23.5 21.1673 23.5 21.859 23.2424 22.3902C23.0156 22.8473 22.6541 23.2304 22.2099 23.4651C21.7042 23.7369 21.0426 23.7369 19.7194 23.7369H19.0105C17.6873 23.7369 17.0257 23.7369 16.52 23.4651C16.0758 23.2304 15.7143 22.8473 15.4874 22.3902C15.2299 21.859 15.2299 21.1673 15.2299 19.7837V19.0423Z"
        stroke="#0F0F1C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BottomActiveBar = () => {
  return (
    <svg width="52" height="3" viewBox="0 0 52 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49 3C50.6569 3 52 1.65685 52 -2.38419e-06L-1.31134e-07 -1.11194e-07C-5.87108e-08 1.65686 1.34315 3 3 3L49 3Z"
        fill="url(#paint0_linear_5101_18217)"
        fill-opacity="0.6"
      />
      <path
        d="M49 3C50.6569 3 52 1.65685 52 -2.38419e-06L-1.31134e-07 -1.11194e-07C-5.87108e-08 1.65686 1.34315 3 3 3L49 3Z"
        fill="#2F3A79"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5101_18217"
          x1="26"
          y1="3"
          x2="26"
          y2="-1.24769e-06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2F3A79" />
          <stop offset="1" stop-color="#CA373C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const MuteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26.73" height="21.921" viewBox="0 0 26.73 21.921">
      <g id="Group_6443" data-name="Group 6443" transform="translate(-364.303 -239.5)">
        <g id="Group_6445" data-name="Group 6445">
          <path
            id="Path_17773"
            data-name="Path 17773"
            d="M15.585,4.545v16.8a2.554,2.554,0,0,1-4.042,2.078L8.123,20.989A5.993,5.993,0,0,0,5.817,19.98,5.985,5.985,0,0,1,1,14.11V11.776a5.985,5.985,0,0,1,4.817-5.87,6.157,6.157,0,0,0,2.307-1l3.419-2.443A2.554,2.554,0,0,1,15.585,4.545Z"
            transform="translate(363.303 237.518)"
            fill="#333"
          />
          <g id="Group_6444" data-name="Group 6444">
            <path
              id="Path_17779"
              data-name="Path 17779"
              d="M383.449,254.766a1,1,0,0,1-.709-1.705l6.311-6.344a1,1,0,1,1,1.418,1.41l-6.311,6.344A1,1,0,0,1,383.449,254.766Z"
              fill="#333"
            />
            <path
              id="Path_17780"
              data-name="Path 17780"
              d="M390.033,254.678a1,1,0,0,1-.707-.293l-6.279-6.279a1,1,0,0,1,1.414-1.414l6.279,6.279a1,1,0,0,1-.707,1.707Z"
              fill="#333"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PauseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.582" height="21.934" viewBox="0 0 15.582 21.934">
      <g id="Group_6447" data-name="Group 6447" transform="translate(-279.845 -254.957)">
        <path
          id="Path_17774"
          data-name="Path 17774"
          d="M281.845,275.023a2,2,0,0,1-2-2V255.09a2,2,0,0,1,4,0v17.934A2,2,0,0,1,281.845,275.023Z"
          transform="translate(0 1.867)"
          fill="#333"
        />
        <path
          id="Path_17775"
          data-name="Path 17775"
          d="M293.427,274.9a2,2,0,0,1-2-2V255.09a2,2,0,0,1,4,0V272.9A2,2,0,0,1,293.427,274.9Z"
          transform="translate(0 1.867)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const PlayIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.833" height="23.648" viewBox="0 0 20.833 23.648">
      <path
        id="Path_17768"
        data-name="Path 17768"
        d="M1,12.776c0-5.212,0-7.8,1.089-9.264a5.435,5.435,0,0,1,3.98-2.169c1.812-.136,4,1.269,8.385,4.093l.588.382c3.8,2.442,5.7,3.656,6.361,5.212a5.473,5.473,0,0,1,0,4.257c-.656,1.555-2.558,2.769-6.361,5.212l-.588.382C10.071,23.7,7.88,25.109,6.069,24.973A5.436,5.436,0,0,1,2.089,22.8C1,21.344,1,18.751,1,13.54Z"
        transform="translate(-1 -1.333)"
        fill="#333"
      />
    </svg>
  );
};

export const StopIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.199" height="20.199" viewBox="0 0 20.199 20.199">
      <path
        id="Path_17769"
        data-name="Path 17769"
        d="M1,6.386C1,4.5,1,3.559,1.367,2.835A3.4,3.4,0,0,1,2.838,1.37C3.559,1,4.5,1,6.386,1h9.426c1.885,0,2.828,0,3.548.37a3.4,3.4,0,0,1,1.471,1.465c.367.724.367,1.666.367,3.551v9.426c0,1.885,0,2.828-.367,3.551a3.4,3.4,0,0,1-1.471,1.465c-.72.37-1.663.37-3.548.37H6.386c-1.885,0-2.828,0-3.548-.37a3.4,3.4,0,0,1-1.471-1.465C1,18.64,1,17.7,1,15.813Z"
        transform="translate(-1 -1)"
        fill="#333"
      />
    </svg>
  );
};

export const UnMuteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25.606" height="21.921" viewBox="0 0 25.606 21.921">
      <g id="Group_6442" data-name="Group 6442" transform="translate(-364.303 -239.5)">
        <path
          id="Path_17773"
          data-name="Path 17773"
          d="M15.585,4.545v16.8a2.554,2.554,0,0,1-4.042,2.078L8.123,20.989A5.993,5.993,0,0,0,5.817,19.98,5.985,5.985,0,0,1,1,14.11V11.776a5.985,5.985,0,0,1,4.817-5.87,6.157,6.157,0,0,0,2.307-1l3.419-2.443A2.554,2.554,0,0,1,15.585,4.545Z"
          transform="translate(363.303 237.518)"
          fill="#333"
        />
        <path
          id="Path_17777_-_Outline"
          data-name="Path 17777 - Outline"
          d="M16,14a1,1,0,0,1-.635-1.773,1.763,1.763,0,0,0,.476-.586l.006-.012a1.373,1.373,0,0,0,0-1.257l0-.006a1.775,1.775,0,0,0-.472-.587,1,1,0,1,1,1.255-1.558,3.789,3.789,0,0,1,1.006,1.25,3.373,3.373,0,0,1,0,3.054,3.749,3.749,0,0,1-1,1.248A1,1,0,0,1,16,14Z"
          transform="translate(367.909 240.018)"
          fill="#333"
        />
        <path
          id="Path_17778_-_Outline"
          data-name="Path 17778 - Outline"
          d="M17,19a1,1,0,0,1-.443-1.9,5.517,5.517,0,0,0,1.781-1.39,6.813,6.813,0,0,0,1.224-2.144A7.689,7.689,0,0,0,20,11a7.793,7.793,0,0,0-.436-2.567,6.821,6.821,0,0,0-1.227-2.148A5.514,5.514,0,0,0,16.558,4.9,1,1,0,0,1,17.442,3.1a7.506,7.506,0,0,1,2.423,1.89A8.814,8.814,0,0,1,21.451,7.77a9.776,9.776,0,0,1,0,6.464,8.807,8.807,0,0,1-1.583,2.772A7.509,7.509,0,0,1,17.442,18.9,1,1,0,0,1,17,19Z"
          transform="translate(367.909 239.6)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const CheckForPublish = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-check-lg"
      viewBox="0 0 16 16"
    >
      <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
    </svg>
  );
};


export const CloseForPublic = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
</svg>
  );
};

export const ChatUserIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg"  width="37" height="38" viewBox="0 0 37 38">
  <defs>
    <clipPath id="clip-path">
      <path id="Rectangle_4108" data-name="Rectangle 4108" d="M8,0h7a8,8,0,0,1,8,8v3a4,4,0,0,1-4,4H3a3,3,0,0,1-3-3V8A8,8,0,0,1,8,0Z" transform="translate(19708 -14256)" fill="#4374E0"/>
    </clipPath>
  </defs>
  <g id="Group_7611" data-name="Group 7611" transform="translate(-19701 14279)">
    <circle id="Ellipse_1118" data-name="Ellipse 1118" cx="18.5" cy="18.5" r="18.5" transform="translate(19701 -14279)" fill="#A0C3FF"/>
    <g id="Mask_Group_2912" data-name="Mask Group 2912" clip-path="url(#clip-path)">
      <circle id="Ellipse_1117" data-name="Ellipse 1117" cx="18.5" cy="18.5" r="18.5" transform="translate(19701 -14279)" fill="#4374E0"/>
    </g>
    <rect id="Rectangle_4110" data-name="Rectangle 4110" width="15" height="15" rx="7.5" transform="translate(19712 -14272)" fill="#4374E0"/>
  </g>
</svg>
}

export const CrownIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" d="M7.51 4.87C7.01 6.27 6.45 6.95 5.94 7c-.57.07-1.07-.18-1.54-.8a.54.54 0 0 0-.1-.1 1 1 0 1 0-.8.4l.01.12.82 3.24A1.5 1.5 0 0 0 5.78 11h4.44a1.5 1.5 0 0 0 1.45-1.14l.82-3.24a.54.54 0 0 0 .01-.12 1 1 0 1 0-.8-.4.54.54 0 0 0-.1.09c-.49.62-1 .87-1.54.81-.5-.05-1.04-.74-1.57-2.13a1 1 0 1 0-.98 0zM11 11.75a.5.5 0 1 1 0 1H5a.5.5 0 1 1 0-1h6z"></path></svg>
}

export const ReturnIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
</svg>
}

export const SendIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="19.944" height="19.946" viewBox="0 0 19.944 19.946">
  <path id="Path_19153" data-name="Path 19153" d="M7.539,12.46,2.063,9.47A2.019,2.019,0,0,1,2.088,5.9,51.8,51.8,0,0,1,14.646,1.39c1.254-.27,2.687-.83,3.739.23s.5,2.48.221,3.73A51.43,51.43,0,0,1,14.1,17.91a2.022,2.022,0,0,1-3.574.03Zm0,0,3.309-3.31" transform="translate(0 -0.055)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>
}

export const SoundIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="20.297" height="18.565" viewBox="0 0 20.297 18.565">
  <path id="Path_19155" data-name="Path 19155" d="M14.722,12.062a2.527,2.527,0,0,0,.677-.842,2.171,2.171,0,0,0,0-1.976,2.527,2.527,0,0,0-.677-.842m.915,8.233a5.992,5.992,0,0,0,1.923-1.5,7.174,7.174,0,0,0,1.285-2.25,8.029,8.029,0,0,0,0-5.306,7.174,7.174,0,0,0-1.285-2.25,5.992,5.992,0,0,0-1.923-1.5m-3.659.082V16.554a1.923,1.923,0,0,1-3.043,1.564l-2.573-1.83a4.511,4.511,0,0,0-1.736-.759A4.5,4.5,0,0,1,1,11.111V9.354A4.5,4.5,0,0,1,4.625,4.936a4.634,4.634,0,0,0,1.736-.75L8.935,2.347A1.923,1.923,0,0,1,11.978,3.911Z" transform="translate(0 -0.95)" fill="none" stroke="#303a47" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>
}

export const StopSoundIcon = () => {
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19 10C19 12.3869 18.0518 14.6762 16.364 16.364C14.6761 18.0518 12.3869 19 10 19C7.61305 19 5.32386 18.0518 3.63603 16.364C1.9482 14.6762 1 12.3869 1 10C1 7.61305 1.9482 5.32381 3.63603 3.63599C5.32386 1.94816 7.61305 1 10 1C12.3869 1 14.6761 1.94816 16.364 3.63599C18.0518 5.32381 19 7.61305 19 10Z" fill="#303A47" stroke="#303A47" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
}

export const BreadRightArrow = () => {
    return (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
  </svg>
    );
  }


export const QuestionIcon = () => {
  return (
 <svg xmlns="http://www.w3.org/2000/svg" width="22.505" height="22.505" viewBox="0 0 22.505 22.505">
  <g id="noun-question-5752545" transform="translate(-0.25 -0.25)">
    <path id="Path_14419" data-name="Path 14419" d="M1.929,18.468a.536.536,0,0,1-.437-.846A5.852,5.852,0,0,0,2.541,15c.016-.12.028-.24.036-.358a8.527,8.527,0,1,1,3.036,2.069,7.018,7.018,0,0,1-3.6,1.747A.56.56,0,0,1,1.929,18.468ZM8.788,1.322A7.466,7.466,0,0,0,3.5,14.063a.537.537,0,0,1,.156.394c-.007.217-.025.452-.057.688a6.778,6.778,0,0,1-.56,1.928,5.8,5.8,0,0,0,1.942-1.24l.129-.129a.537.537,0,0,1,.6-.11,7.374,7.374,0,0,0,3.071.66,7.466,7.466,0,1,0,0-14.932Z" transform="translate(0)" fill="#fff"/>
    <path id="Path_14420" data-name="Path 14420" d="M24.269,25.008A.546.546,0,0,1,24.177,25a7.035,7.035,0,0,1-3.592-1.745A8.539,8.539,0,0,1,11.6,21.578a.536.536,0,0,1,.73-.785,7.464,7.464,0,0,0,8.152,1.341.537.537,0,0,1,.6.111l.135.136a5.789,5.789,0,0,0,1.935,1.231,6.892,6.892,0,0,1-.56-1.924c-.031-.234-.047-.473-.054-.69a.537.537,0,0,1,.155-.4A7.458,7.458,0,0,0,21.55,9.122a.536.536,0,1,1,.593-.892,8.529,8.529,0,0,1,1.479,12.954c.008.119.018.24.034.36A5.908,5.908,0,0,0,24.7,24.16a.535.535,0,0,1-.435.848Z" transform="translate(-3.192 -2.253)" fill="#fff"/>
    <path id="Path_14421" data-name="Path 14421" d="M10.886,12.725a.536.536,0,0,1-.536-.536V11.94a2.542,2.542,0,0,1,1.275-2.27,1.931,1.931,0,0,0,.927-2.137A1.78,1.78,0,0,0,11.29,6.172a1.614,1.614,0,0,0-1.407.3,1.93,1.93,0,0,0-.712,1.513.536.536,0,1,1-1.072,0A3.007,3.007,0,0,1,9.221,5.632a2.7,2.7,0,0,1,2.322-.5A2.834,2.834,0,0,1,13.6,7.309a3,3,0,0,1-1.479,3.311,1.465,1.465,0,0,0-.7,1.319v.249a.536.536,0,0,1-.536.536Z" transform="translate(-2.242 -1.371)" fill="#fff"/>
    <circle id="Ellipse_649" data-name="Ellipse 649" cx="0.75" cy="0.75" r="0.75" transform="translate(7.894 12.447)" fill="#fff"/>
  </g>
</svg>
  );
}

export const QuestionMainIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-lg" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4.475 5.458c-.284 0-.514-.237-.47-.517C4.28 3.24 5.576 2 7.825 2c2.25 0 3.767 1.36 3.767 3.215 0 1.344-.665 2.288-1.79 2.973-1.1.659-1.414 1.118-1.414 2.01v.03a.5.5 0 0 1-.5.5h-.77a.5.5 0 0 1-.5-.495l-.003-.2c-.043-1.221.477-2.001 1.645-2.712 1.03-.632 1.397-1.135 1.397-2.028 0-.979-.758-1.698-1.926-1.698-1.009 0-1.71.529-1.938 1.402-.066.254-.278.461-.54.461h-.777ZM7.496 14c.622 0 1.095-.474 1.095-1.09 0-.618-.473-1.092-1.095-1.092-.606 0-1.087.474-1.087 1.091S6.89 14 7.496 14"/>
</svg>
  )
}

export const TutorialIcon = () => {
  return (
<svg id="Group_7954" data-name="Group 7954" xmlns="http://www.w3.org/2000/svg" width="86.865" height="86.865" viewBox="0 0 86.865 86.865">
  <path id="Path_19161" data-name="Path 19161" d="M86.865,43.433A43.433,43.433,0,1,0,43.433,86.865,43.433,43.433,0,0,0,86.865,43.433Z" fill="none"/>
  <path id="Subtraction_26" data-name="Subtraction 26" d="M-14805.842,14384.711h-37.789a12.8,12.8,0,0,1-9.147-3.824,13.029,13.029,0,0,1-3.79-9.232v-20.16a13.037,13.037,0,0,1,3.79-9.236,12.791,12.791,0,0,1,9.147-3.825h37.789a12.785,12.785,0,0,1,9.146,3.825,13.043,13.043,0,0,1,3.788,9.236v20.16a13.034,13.034,0,0,1-3.788,9.232A12.791,12.791,0,0,1-14805.842,14384.711Zm-38.109-40.152a6.749,6.749,0,0,0-6.708,6.774v20.481a6.747,6.747,0,0,0,6.708,6.771h38.43a6.747,6.747,0,0,0,6.707-6.771v-20.481a6.749,6.749,0,0,0-6.707-6.774Z" transform="translate(14868.17 -14322.117)" fill="#fff" stroke="#fff" stroke-width="1"/>
  <path id="Path_19218" data-name="Path 19218" d="M1.469,9.72c0-3.82,0-5.72.8-6.79A3.983,3.983,0,0,1,5.184,1.34c1.328-.1,2.934.93,6.146,3l.431.28c2.787,1.79,4.181,2.68,4.662,3.82a4.012,4.012,0,0,1,0,3.12c-.481,1.14-1.875,2.03-4.662,3.82l-.431.28c-3.212,2.07-4.818,3.1-6.146,3a3.984,3.984,0,0,1-2.917-1.59c-.8-1.07-.8-2.97-.8-6.79Z" transform="translate(33.964 29.456)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
</svg>
  );
}

export const AIChatBot = () => {
  return (
 <svg id="Group_7955" data-name="Group 7955" xmlns="http://www.w3.org/2000/svg" width="86.865" height="86.865" viewBox="0 0 86.865 86.865">
  <path id="Path_19161" data-name="Path 19161" d="M86.865,43.433A43.433,43.433,0,1,0,43.433,86.865,43.433,43.433,0,0,0,86.865,43.433Z" fill="none"/>
  <path id="Path_19162" data-name="Path 19162" d="M21.737,50.151a.248.248,0,0,1,.093-.11.254.254,0,0,1,.277,0,.25.25,0,0,1,.093.11,10.045,10.045,0,0,0,1.587,2.957,10.26,10.26,0,0,0,2.871,1.569.248.248,0,0,1,.108.091.244.244,0,0,1,0,.269.248.248,0,0,1-.108.091A10.23,10.23,0,0,0,23.787,56.7,10.052,10.052,0,0,0,22.2,59.656a.25.25,0,0,1-.093.11.254.254,0,0,1-.277,0,.248.248,0,0,1-.093-.11A10.045,10.045,0,0,0,20.15,56.7a10.293,10.293,0,0,0-3-1.567.25.25,0,0,1-.111-.091.245.245,0,0,1,0-.274.25.25,0,0,1,.111-.091,10.269,10.269,0,0,0,3-1.567A10.068,10.068,0,0,0,21.737,50.151Z" transform="translate(6.818 20.053)" fill="#fff"/>
  <path id="Path_19163" data-name="Path 19163" d="M47.054,12.231a.41.41,0,0,1,.737,0,6.339,6.339,0,0,0,1.02,1.8,6.411,6.411,0,0,0,1.742,1.025.407.407,0,0,1,0,.727,6.411,6.411,0,0,0-1.742,1.025,6.34,6.34,0,0,0-1.02,1.806.41.41,0,0,1-.737,0,6.342,6.342,0,0,0-1.02-1.8,6.346,6.346,0,0,0-1.8-1.022.41.41,0,0,1,0-.737,6.344,6.344,0,0,0,1.8-1.02A6.341,6.341,0,0,0,47.054,12.231Z" transform="translate(17.646 4.813)" fill="#fff"/>
  <path id="Path_19164" data-name="Path 19164" d="M16.653,10.547a.439.439,0,0,1,.77,0,3.33,3.33,0,0,0,.541.884,3.434,3.434,0,0,0,.866.549.435.435,0,0,1,0,.757,3.43,3.43,0,0,0-.866.549,3.33,3.33,0,0,0-.541.884.439.439,0,0,1-.77,0,3.327,3.327,0,0,0-.541-.884,3.325,3.325,0,0,0-.884-.541.44.44,0,0,1,0-.77,3.328,3.328,0,0,0,.884-.544A3.327,3.327,0,0,0,16.653,10.547Z" transform="translate(6.016 4.139)" fill="#fff"/>
  <path id="Path_19165" data-name="Path 19165" d="M47.653,49.227a.44.44,0,0,1,.77,0,3.328,3.328,0,0,0,.541.884,3.43,3.43,0,0,0,.866.549.435.435,0,0,1,0,.757,3.43,3.43,0,0,0-.866.549,3.328,3.328,0,0,0-.541.884.44.44,0,0,1-.77,0,2.211,2.211,0,0,0-1.425-1.425.44.44,0,0,1,0-.77,2.23,2.23,0,0,0,1.425-1.428Z" transform="translate(18.448 19.652)" fill="#fff"/>
  <path id="Path_19166" data-name="Path 19166" d="M33.875,16.381a.3.3,0,0,1,.18-.267,3.673,3.673,0,1,0-2.768.061.3.3,0,0,1,.193.272v2.4a.288.288,0,0,1-.236.281,6.878,6.878,0,0,0-.785.2,5.937,5.937,0,0,0-1.813.926,4.4,4.4,0,0,0-1.212,1.386,3.461,3.461,0,0,0-.414,1.355.262.262,0,0,0,.268.28H37.906a.262.262,0,0,0,.268-.28,3.463,3.463,0,0,0-.414-1.355,4.4,4.4,0,0,0-1.212-1.386,5.937,5.937,0,0,0-1.813-.926q-.31-.1-.631-.167a.288.288,0,0,1-.23-.28Z" transform="translate(10.836 3.609)" fill="#fff" stroke="#fff" stroke-width="1"/>
  <path id="Path_19168" data-name="Path 19168" d="M13.631,28.843a.268.268,0,0,0-.28-.272,4.733,4.733,0,0,0-1.492.335,4.641,4.641,0,0,0-1.5.979,4.509,4.509,0,0,0-1,1.465,4.41,4.41,0,0,0,0,3.456,4.51,4.51,0,0,0,1,1.465,4.641,4.641,0,0,0,1.5.979,4.73,4.73,0,0,0,1.492.335.268.268,0,0,0,.28-.272Z" transform="translate(3.609 11.458)" fill="#fff" stroke="#fff" stroke-width="1"/>
  <path id="Path_19169" data-name="Path 19169" d="M28.086,34.32a.268.268,0,0,0-.272.28,4.857,4.857,0,0,0,.332,1.509,4.694,4.694,0,0,0,.969,1.517,4.461,4.461,0,0,0,1.451,1.014,4.291,4.291,0,0,0,3.422,0,4.461,4.461,0,0,0,1.451-1.014,4.694,4.694,0,0,0,.969-1.517,4.857,4.857,0,0,0,.332-1.509.268.268,0,0,0-.272-.28Z" transform="translate(11.155 13.764)" fill="#fff" stroke="#fff" stroke-width="1"/>
  <path id="Path_19170" data-name="Path 19170" d="M34.534,30.927a3.755,3.755,0,1,1,3.753,3.628A3.692,3.692,0,0,1,34.534,30.927Z" transform="translate(13.85 10.948)" fill="#fff" stroke="#fff" stroke-width="1"/>
  <path id="Path_19171" data-name="Path 19171" d="M22.109,30.927a3.755,3.755,0,1,1,3.753,3.628A3.692,3.692,0,0,1,22.109,30.927Z" transform="translate(8.867 10.948)" fill="#fff" stroke="#fff" stroke-width="1"/>
  <path id="Path_19172" data-name="Path 19172" d="M49.694,28.843a.268.268,0,0,1,.28-.272,4.733,4.733,0,0,1,1.492.335,4.642,4.642,0,0,1,1.5.979,4.512,4.512,0,0,1,1,1.465,4.411,4.411,0,0,1,0,3.456,4.513,4.513,0,0,1-1,1.465,4.641,4.641,0,0,1-1.5.979,4.73,4.73,0,0,1-1.492.335.268.268,0,0,1-.28-.272Z" transform="translate(19.93 11.458)" fill="#fff" stroke="#fff" stroke-width="1"/>
  <path id="Subtraction_25" data-name="Subtraction 25" d="M-14923.794,14392.354a.285.285,0,0,1-.224-.109.273.273,0,0,1-.049-.238l2.836-11.948a.28.28,0,0,0-.054-.239.271.271,0,0,0-.217-.105h-13.129a12.8,12.8,0,0,1-9.149-3.824,13.037,13.037,0,0,1-3.789-9.234V14356.5a13.042,13.042,0,0,1,3.789-9.236,12.794,12.794,0,0,1,9.149-3.825h27.786a12.8,12.8,0,0,1,9.149,3.825,13.042,13.042,0,0,1,3.789,9.236v10.159a13.037,13.037,0,0,1-3.789,9.234,12.8,12.8,0,0,1-9.149,3.824h-.323a.285.285,0,0,0-.169.06l-16.288,12.522A.274.274,0,0,1-14923.794,14392.354Zm-11.155-42.794a6.749,6.749,0,0,0-6.707,6.774v10.478a6.749,6.749,0,0,0,6.707,6.775h28.428a6.749,6.749,0,0,0,6.707-6.775v-10.478a6.749,6.749,0,0,0-6.707-6.774Z" transform="translate(14964.169 -14317.117)" fill="#fff" stroke="#fff" stroke-width="1"/>
</svg>
  );
}